<template>
  <div class="assignment-detail-panel">
    <v-card class="assignment-detail-card">
      <v-card-text class="assignment-detail-body">
        <v-alert outline color="error" v-if="error">{{ error }}</v-alert>
        <v-layout class="assignment-detail-toolbar">
          <div
            class="heading orange--text pb-2"
            style="text-align: initial"
            v-if="this.milestoneTrack.milestone.length > 0"
          >
            Milestone Information
          </div>
          <v-spacer />
          <changeMilestone
            v-if="
              (this.milestoneTrack.milestone.length > 0 &&
                detail.assignmentStatus == 2) ||
              (this.milestoneTrack.milestone.length > 0 &&
                detail.assignmentStatus === 5) ||
              (this.milestoneTrack.milestone.length > 0 &&
                detail.assignmentStatus === 7)
            "
            v-permissions="'change-milestone'"
            :assignmentDetails="detail"
          ></changeMilestone>
          <ViewComment
            v-permissions="'view-comments-jobs'"
            :job-id="detail.jobId"
            :assignmentId="detail.assignmentId"
          />
        </v-layout>

        <div
          class="assignment-milestone-board"
          v-if="this.milestoneTrack.milestone.length > 0"
        >
          <v-layout>
            <v-stepper class="assignment-milestone-flow">
              <v-stepper-header class="assignment-milestone-track">
                <template v-for="(milestone, n) in milestoneTrack.milestone">
                  <!-- {{ milestoneTrack.milestone[n + 1].isVisaExpiry }} -->
                  <v-stepper-step
                    :key="`${n + 1}-step`"
                    :step="n + 1"
                    v-if="milestone.isChecked"
                    :disabled="detail.assignmentStatus == -1"
                    class="assignment-milestone-card assignment-milestone-card--done"
                    complete
                  >
                    <!-- {{ milestone }}
                    {{ milestoneTrack.milestone[n + 1].isVisaExpiry }} -->

                    <!-- DUe to change milestone live -->
                    <div class="assignment-milestone-card__top">
                      <span class="assignment-milestone-badge">Completed</span>
                      <span class="assignment-milestone-actions">
                        <v-icon
                          flat
                          prepend-icon
                          color="blue"
                          v-if="detail.assignmentStatus != -1"
                          :disabled="viewOnly == 'view'"
                          @click.native="
                            addCommentx.error = '';
                            editMilestoneComment(
                              milestoneTrack.assId,
                              milestone.mileStoneId,
                              n
                            );
                          "
                          title="Edit Comment"
                          class="assignment-milestone-comment viewDetail"
                          style="cursor: pointer"
                          >chat_bubble_outline</v-icon
                        >
                        <v-icon
                          flat
                          prepend-icon
                          color="blue"
                          v-else
                          :disabled="viewOnly == 'view'"
                          @click.native="
                            addCommentx.error = '';
                            editMilestoneComment(
                              milestoneTrack.assId,
                              milestone.mileStoneId,
                              n
                            );
                          "
                          title="Edit Comment"
                          class="assignment-milestone-comment viewDetail"
                          style="cursor: pointer"
                          >chat_bubble_outline</v-icon
                        >
                        <span
                          v-if="
                            detail.assignmentStatus == 5 ||
                            detail.assignmentStatus == 6 ||
                            detail.assignmentStatus == 7
                          "
                        >
                          <v-icon
                            flat
                            prepend-icon
                            v-if="checkLastMilestoneStatus(n)"
                            color="red"
                            left
                            title="Unmark milestone"
                            class="assignment-milestone-reverse"
                            @click="
                              unmarkMilestone(
                                detail.assignmentId,
                                detail.milestoneData['_id'],
                                milestone.mileStoneId,
                                milestone.mileStoneName
                              )
                            "
                          >
                            close
                          </v-icon>
                        </span>
                      </span>
                    </div>
                    <strong class="assignment-milestone-title">
                      {{ milestone.mileStoneName }}
                    </strong>
                    <div class="assignment-milestone-details">
                      <div
                        class="assignment-milestone-detail"
                        v-if="milestone.usersData.length"
                      >
                        <span class="assignment-milestone-detail__label"
                          >Marked by</span
                        >
                        <span class="assignment-milestone-detail__value"
                          >{{ milestone.usersData[0].name }} ({{
                            milestone.usersData[0].employeeID
                          }})</span
                        >
                      </div>
                      <div
                        class="assignment-milestone-detail"
                        v-if="milestone.driverData"
                      >
                        <span class="assignment-milestone-detail__label"
                          >Marked by</span
                        >
                        <span class="assignment-milestone-detail__value"
                          >{{ milestone.driverData.name }} ({{
                            milestone.driverData.driverId
                          }})</span
                        >
                      </div>
                      <div
                        class="assignment-milestone-detail"
                        v-if="milestone.transporterData"
                      >
                        <span class="assignment-milestone-detail__label"
                          >Marked by</span
                        >
                        <span class="assignment-milestone-detail__value"
                          >{{ milestone.transporterData.transporterName }} ({{
                            milestone.transporterData.transporterId
                          }})</span
                        >
                      </div>
                      <div
                        class="assignment-milestone-detail"
                        v-if="milestone.updatedDate"
                      >
                        <span class="assignment-milestone-detail__label"
                          >Actual date</span
                        >
                        <span class="assignment-milestone-detail__value"
                          >{{ getTimes(milestone.updatedDate) }}</span
                        >
                      </div>
                    </div>
                  </v-stepper-step>

                  <v-stepper-step
                    :key="`${n + 1}-step`"
                    :step="n + 1"
                    class="assignment-milestone-card assignment-milestone-card--active step-clickable"
                    editable
                    v-else-if="
                      currentMilestone == n && detail.assignmentStatus != -1
                    "
                    :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
                    @click="openInfoMilestone(milestone.mileStoneId, n)"
                  >
                    <div class="assignment-milestone-card__top">
                      <span class="assignment-milestone-badge">Current</span>
                    </div>
                    <strong class="assignment-milestone-title">
                      {{ milestone.mileStoneName }}
                    </strong>
                    <small class="assignment-milestone-hint">
                      Click to update milestone
                    </small>
                  </v-stepper-step>

                  <v-stepper-step
                    :key="`${n + 1}-step`"
                    :step="n + 1"
                    class="assignment-milestone-card assignment-milestone-card--pending"
                    v-else
                  >
                    <div class="assignment-milestone-card__top">
                      <span class="assignment-milestone-badge">Pending</span>
                    </div>
                    <strong class="assignment-milestone-title">
                      {{ milestone.mileStoneName }}
                    </strong>
                    <small class="assignment-milestone-hint">
                      Waiting for prior milestone
                    </small>
                  </v-stepper-step>

                  <v-divider
                    class="assignment-milestone-divider divider"
                    v-if="n + 2 <= milestoneTrack.milestone.length"
                    :key="n + 1"
                    >{{ n }}</v-divider
                  >
                </template>
              </v-stepper-header>
            </v-stepper>
          </v-layout>
        </div>
        <v-divider
          class="my-1 mb-4"
          v-if="this.milestoneTrack.milestone.length > 0"
        />
        <div
          v-if="
            (working != 'PAK' && status != 1) ||
            (working != 'PAK' && status == 1) ||
            (working != 'PAK' && status != 1)
          "
          class="heading orange--text pb-2"
          style="text-align: initial"
        >
          Assignment Information
        </div>
        <v-layout row> </v-layout>
        <v-layout row class="py-4" style="text-align: initial">
          <v-flex xs4 v-if="detail.wayBillNo">
            <div class="subheading muted">Waybill Number</div>
            <div class="heading">{{ detail.wayBillNo }}</div>
          </v-flex>
          <v-flex xs4 v-if="detail.paymentAmount">
            <div class="subheading muted">
              {{ getOperatorAmountLabel(jobType) }}
            </div>
            <div class="heading">
              {{
                detail.paymentCurrency +
                " " +
                $formatPrice(detail.paymentAmount)
              }}
            </div>
          </v-flex>
          <v-flex xs4 v-if="detail.invoiceAmount">
            <div class="subheading muted">Invoice Amount(Assign. Level)</div>
            <div class="heading">
              {{
                detail.paymentCurrency +
                " " +
                parseFloat(detail.invoiceAmount).toFixed(2)
              }}
            </div>
          </v-flex>
          <v-flex
            xs4
            v-permissions="'generate-purchase-invoice'"
            v-if="
              detail.isReadyToGeneratePurchaseInvoice &&
              !detail.isPurchaseInvoiceGenerated &&
              !detail.isPurchaseOrderInQueue &&
              profile.workOrderCompleted &&
              working != 'PAK' &&
              working != 'OMAN' &&
              detail.assignmentStatus != -1
            "
          >
            <div class="subheading muted">Generate Purchase Invoice</div>
            <div class="heading">
              <div v-if="detail.showPurchaseInvoiceButton">
                <button
                  @click="openPiPopup(detail._id)"
                  v-permissions="'generate-purchase-invoice'"
                  target="_blank"
                  v-if="!detail.isPurchaseInvoviceBackgroundProcess"
                  :disabled="loading || viewOnly == 'view'"
                  class="orange-button pi-generate-btn"
                  title="Generate"
                >
                  Generate
                </button>
                <div
                  v-if="detail.isPurchaseInvoviceBackgroundProcess"
                  style="word-break: break-word"
                  class="subheading muted"
                >
                  Purchase Invoice can't be generated, Background process is
                  ongoing.
                </div>
              </div>
              <div v-else>N.A</div>
            </div>
          </v-flex>

          <v-flex
            xs4
            v-if="
              detail.invoiceNumber &&
              detail.isPurchaseInvoiceGenerated &&
              profile.workOrderCompleted &&
              working != 'PAK' &&
              (detail.assignmentStatus != 1 || detail.assignmentStatus != -1)
            "
          >
            <div v-if="working != 'PAK'" class="subheading muted">
              Purchase Invoice Number
            </div>
            <div v-if="working != 'PAK'" class="heading">
              {{ detail.invoiceNumber }}
            </div>
          </v-flex>
          <div v-if="detail.invoiceNumber == 'NA'"></div>
          <div v-else>
            <v-flex
              xs4
              v-permissions="'view-purchase-invoice'"
              v-if="
                detail.invoicePdfUrl &&
                detail.isPurchaseInvoiceGenerated &&
                profile.workOrderCompleted &&
                working != 'PAK' &&
                working != 'OMAN' &&
                detail.assignmentStatus != -1
              "
            >
              <div
                class="subheading muted pl-2"
                style="text-align: center !important"
              >
                View Purchase Invoice
              </div>
              <div class="heading">
                <div>
                  <v-btn
                    v-if="detail.isPurchaseInvoiceDownloadAllowed"
                    :disabled="loading || viewOnly == 'view'"
                    outline
                    style="padding: 0 5px"
                    @click="
                      checkViewInvoice(
                        detail.invoicePdfUrl,
                        detail.isDownloadInvocie,
                        detail.isPurchaseInvoviceBackgroundProcess,
                        detail.invoiceNumber
                      )
                    "
                    color="orange"
                    ><v-icon style="margin: 0px !important" right dark
                      >download</v-icon
                    >
                    Download
                  </v-btn>
                  <v-btn
                    v-permissions="'pi-download-control'"
                    v-if="detail.isPurchaseInvoiceDownloadAllowed"
                    class="download-ass-btn"
                    outline
                    :loading="loading"
                    :disabled="loading"
                    title="hide"
                    color="orange"
                    @click="hideUnhidePI(false, detail._id)"
                  >
                    Hide
                  </v-btn>
                  <v-btn
                    v-permissions="'pi-download-control'"
                    v-if="!detail.isPurchaseInvoiceDownloadAllowed"
                    class="download-ass-btn"
                    outline
                    :loading="loading"
                    :disabled="loading"
                    title="hide"
                    color="orange"
                    @click="hideUnhidePI(true, detail._id)"
                  >
                    Unhide
                  </v-btn>
                </div>
              </div>
            </v-flex>

            <v-flex
              xs3
              v-if="
                !detail.invoicePdfUrl &&
                !detail.isPurchaseInvoiceGenerated &&
                working != 'PAK' &&
                working != 'OMAN' &&
                detail.assignmentStatus != -1
              "
            >
              <div class="subheading muted pr-2">View Purchase Invoice</div>
              <div class="heading pr-2">
                <div>
                  <v-btn
                    v-permissions="'pi-download-control'"
                    v-if="detail.isPurchaseInvoiceDownloadAllowed"
                    class="download-ass-btn"
                    outline
                    :loading="loading"
                    :disabled="loading"
                    title="hide"
                    color="orange"
                    @click="hideUnhidePI(false, detail._id)"
                  >
                    Hide
                  </v-btn>
                  <v-btn
                    v-permissions="'pi-download-control'"
                    v-if="!detail.isPurchaseInvoiceDownloadAllowed"
                    class="download-ass-btn"
                    outline
                    :loading="loading"
                    :disabled="loading"
                    title="unhide"
                    color="orange"
                    @click="hideUnhidePI(true, detail._id)"
                  >
                    Unhide
                  </v-btn>
                </div>
              </div>
            </v-flex>
          </div>
          <div v-if="detail.isPurchaseOrderInQueue">
            <div class="subheading muted">Purchase Voucher No:</div>
            Background process is ongoing
          </div>
          <v-flex
            xs4
            v-else-if="
              (detail.assignmentStatus == -1 && working != 'PAK') ||
              (detail.assignmentStatus == -1 && working != 'OMAN')
            "
          >
            <div class="subheading muted">Purchase Voucher No:</div>
            <div class="heading">Assignment is cancelled</div>
          </v-flex>
          <v-flex
            xs4
            v-else-if="
              (detail.assignmentStatus == 8 && working != 'PAK') ||
              (detail.assignmentStatus == 8 && working != 'OMAN')
            "
          >
          </v-flex>

          <v-flex
            xs4
            v-else-if="
              ((detail.assignmentStatus != 1 ||
                detail.assignmentStatus != -1) &&
                !profile.workOrderCompleted &&
                working != 'PAK') ||
              ((detail.assignmentStatus != 1 ||
                detail.assignmentStatus != -1) &&
                !profile.workOrderCompleted &&
                working != 'OMAN')
            "
          >
            <div class="subheading muted">Purchase Voucher No:</div>
            <div class="heading">Work order is not generated</div>
          </v-flex>

          <v-flex
            xs6
            v-else-if="
              !detail.purchaseOrderCreated &&
              detail.errorWhileRealbooks &&
              detail.driverId &&
              working != 'PAK' &&
              working != 'OMAN' &&
              (detail.assignmentStatus != 1 || detail.assignmentStatus != -1)
            "
          >
            <div class="subheading muted">Purchase Voucher No:</div>
            <div v-if="detail.isPurchaseOrderInQueue">
              Background process is ongoing
            </div>
            <div v-else-if="!detail.isPurchaseOrderInQueue">
              <span
                v-if="
                  detail.isPurchaseOrderBackgroundProcess &&
                  detail.errorWhileRealbooks
                "
                >Data inappropriate, kindly update data</span
              >
              <v-btn
                class="track-ass-btn"
                flat
                v-if="
                  !detail.isPurchaseOrderBackgroundProcess &&
                  detail.errorWhileRealbooks
                "
                prepend-icon
                color="white darken-1"
                :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
                @click="retryPO(detail.assignmentId)"
                :loading="poloading"
                :_id="detail.assignmentId"
                >Retry</v-btn
              >
            </div>
          </v-flex>

          <v-flex
            xs4
            v-else-if="
              !detail.purchaseOrderCreated &&
              !detail.errorWhileRealbooks &&
              detail.driverId &&
              working != 'OMAN' &&
              working != 'PAK' &&
              (detail.assignmentStatus != 1 || detail.assignmentStatus != -1)
            "
          >
            <div class="subheading muted">Purchase Voucher No:</div>
            <div v-if="detail.isPurchaseOrderInQueue">
              Background process is ongoing
            </div>
            <div v-else-if="!detail.isPurchaseOrderInQueue">
              <v-btn
                class="track-ass-btn"
                flat
                prepend-icon
                color="white darken-1"
                :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
                @click="retryPO(detail.assignmentId)"
                :_id="detail.assignmentId"
                :loading="poloading"
                >Retry
              </v-btn>
            </div>
          </v-flex>
          <v-flex
            xs4
            v-else-if="
              (detail.voucherIdRealBooks &&
                working != 'PAK' &&
                (detail.assignmentStatus != 1 ||
                  detail.assignmentStatus != -1)) ||
              (detail.voucherIdRealBooks &&
                working != 'OMAN' &&
                (detail.assignmentStatus != 1 || detail.assignmentStatus != -1))
            "
          >
            <div class="subheading muted">Purchase Voucher No:</div>
            <div class="heading">{{ detail.voucherIdRealBooks }}</div>
          </v-flex>

          <v-flex
            xs4
            v-if="
              detail.isPurchaseInvoiceGenerated &&
              working != 'PAK' &&
              detail.assignmentStatus != -1
            "
            v-permissions="'view-sales-invoice'"
          >
            <div class="subheading muted">
              Sales Invoice (Assignment level) :
            </div>
            <div v-if="detail.salesInvoiceNumber == 'NA'">N.A</div>
            <div v-else>
              <div
                class="heading"
                v-if="
                  detail.salesInvoiceNumber && detail.isSalesInvoiceGenerated
                "
              >
                {{ detail.salesInvoiceNumber }}
                <div class="heading">
                  <v-btn
                    outline
                    style="padding: 0 5px"
                    :loading="siAdvanceSaving"
                    :disabled="siAdvanceSaving"
                    @click="openSalesInvoiceDownload()"
                    color="orange"
                    ><v-icon style="margin: 0px !important" right dark
                      >download</v-icon
                    >
                    Download
                  </v-btn>
                </div>
              </div>
              <div v-else>N.A.</div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row class="py-4" style="text-align: initial">
          <v-flex xs2 v-if="detail.isReadyForFinalPayment">
            <div class="subheading muted">
              {{ getOperatorDocumentProofLabel(jobType) }}
            </div>
            <div class="heading">
              <button
                class="track-ass-btn blue-button"
                flat
                prepend-icon
                color="white darken-1"
                @click.stop="goToProof(detail._id)"
              >
                View Docs
              </button>
            </div>
          </v-flex>
          <v-flex xs2 v-if="detail.amountPaidToDriver">
            <div class="subheading muted">Payment Proof</div>
            <div class="heading" style="padding-top: 8px">
              <proof-of-delivery
                :assignId="detail._id"
                :type="'finalPayProof'"
              />
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-layout class="assignment-detail-actions">
          <span class="assignment-detail-note"
            >* Note - Attach Milestone before assigning the driver</span
          >
          <v-spacer />

          <div v-if="!detail.hasVasAttached">
            <!-- <v-btn
              v-permissions="'cancel-assignment-jobs'"
              color="red darken-2"
              class="white--text"
              flat
              :disabled="
                profile.jobStatus == 10 ||
                viewOnly == 'view' ||
                detail.assignmentStatus == -1
              "
              @click="checkCancel()"
              >Cancel Assignment</v-btn
            > -->

            <!-- <v-btn
              v-permissions="'cancel-assignment-jobs'"
              v-if="!detail.isGenerated && detail.assignmentStatus == 8"
              color="red darken-2"
              class="white--text"
              flat
              :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
              @click="checkCancel()"
              >Cancel Assignment</v-btn
            > -->
            <div
              v-if="
                !detail.isGenerated &&
                ((detail.assignmentStatus >= 0 &&
                  detail.assignmentStatus <= 2) ||
                  detail.assignmentStatus == 5 ||
                  detail.assignmentStatus == 8)
              "
            >
              <v-btn
                v-permissions="'cancel-assignment-jobs'"
                color="red darken-2"
                class="white--text"
                flat
                :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
                @click="checkCancel()"
                >Cancel Assignment</v-btn
              >
            </div>

            <div v-else>
              <v-btn
                v-permissions="'cancel-assignment-job-master'"
                color="red darken-2"
                class="white--text"
                flat
                :disabled="
                  profile.jobStatus == 10 ||
                  viewOnly == 'view' ||
                  detail.assignmentStatus == -1
                "
                @click="checkCancel()"
                >Cancel Assignment</v-btn
              >
            </div>
          </div>

          <AddPhysicalDoc
            :assignDetails="detail"
            :section="'jobDetails'"
            :driverCreditDuration="
              detail.driverData ? detail.driverData.driverPaymentDuration : null
            "
            @ready-to-pay="refresh()"
          />
          <EditPhysicalDoc
            v-if="!detail.amountPaidToDriver"
            :assignDetails="detail"
            :section="'jobDetails'"
            :driverCreditDuration="
              detail.driverData ? detail.driverData.driverPaymentDuration : null
            "
            @ready-to-pay="refresh()"
          />

          <!-- <v-btn
            v-permissions="'complete-assignment-jobs'"
            v-if="status === 6"
            :loading="loading"
            color="orange darken-2"
            class="white--text"
            :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
            @click.native="checkComplete()"
            >Complete Assignment</v-btn
          > -->
          <BidResponse
            :id="detail._id"
            :assignmentId="detail.assignmentId"
            :job-id="detail.jobId"
            :startDate="detail.startDate"
            v-if="jobType == 1"
            :disabled="profile.jobStatus == 10 || viewOnly == 'view'"
          />
        </v-layout>
      </v-card-actions>
    </v-card>
    <v-snackbar
      :timeout="3000"
      bottom
      color="red darken-2"
      v-model="error"
      class="white--text"
      v-if="error"
      >{{ error }}</v-snackbar
    >
    <!--- select milestone -->
    <v-dialog
      v-model="dialog3"
      persistent
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark :color="options.color" dense flat>
          <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-show="!!message" class="pa-4">{{ message }}</v-card-text>

        <v-card-actions class="pt-0">
          <v-btn color="primary darken-1" @click.native="selectMilestone"
            >Yes</v-btn
          >
          <v-btn color="grey" text @click.native="cancel3">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--- milestone info -->
    <v-dialog
      v-model="dialog2"
      persistent
      max-width="30rem"
      content-class="milestone-update-dialog"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card class="milestone-update-card">
        <div class="milestone-update-head">
          <span class="milestone-update-head__icon">
            <v-icon>flag</v-icon>
          </span>
          <div class="milestone-update-head__text">
            <strong>Mark milestone as reached</strong>
            <span v-if="milestoneNameById(currentMilestoneId)">{{
              milestoneNameById(currentMilestoneId)
            }}</span>
          </div>
        </div>

        <div class="milestone-update-body">
          <p class="milestone-update-hint">
            Confirm the date and time this milestone was actually reached.
          </p>
          <div class="milestone-update-fields">
            <div class="milestone-update-field">
              <span class="milestone-update-label">Date</span>
              <v-menu
                ref="FilterDateBool"
                lazy
                v-model="FilterDateBool"
                :close-on-content-click="false"
                transition="scale-transition"
                full-width
                :nudge-right="40"
                min-width="290px"
                :return-value.sync="startDate"
              >
                <v-text-field
                  slot="activator"
                  required
                  v-model="startDate"
                  class="milestone-update-input"
                  prepend-inner-icon="event"
                  placeholder="Select date"
                  readonly
                  hide-details
                ></v-text-field>
                <v-date-picker
                  v-model="startDate"
                  class="minHeight"
                  :max="dateToday"
                  @change="$refs.FilterDateBool.save(startDate)"
                  no-title
                  scrollable
                ></v-date-picker>
              </v-menu>
            </div>
            <div class="milestone-update-field">
              <span class="milestone-update-label">Time</span>
              <vue-timepicker
                class="milestone-update-time"
                :minute-interval="30"
                v-model="pickupTime"
                input-width="100%"
                :label="'Actual Milestone Date'"
                placeholder="Select time"
                close-on-complete
              ></vue-timepicker>
            </div>
          </div>
        </div>

        <div class="milestone-update-actions">
          <v-btn
            flat
            class="milestone-update-cancel"
            @click.native="cancel1"
            >Cancel</v-btn
          >
          <v-btn
            flat
            class="milestone-update-submit"
            :loading="loading"
            :disabled="profile.jobStatus == 10 || viewOnly == 'view' || loading"
            @click.native="
              updateMilestone(milestoneTrack.assId, currentMilestoneId)
            "
            >Mark as reached</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <v-dialog
      v-if="confirmationDialog.cancelAssignment"
      v-model="confirmationDialog.cancelAssignment"
      persistent
      max-width="600"
    >
      <v-card>
        <v-card-title dark dense flat style="background-color: #ffc04c">
          <div class="headline white--text">Confirmation of cancellation</div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-flex pt-2 pr-1>
              <div class="subheading muted caption">
                Provide cancellation reason
              </div>
              <v-select
                class="pt-0 currencyTitle"
                v-model="cancelType"
                :items="cancellationType"
                label="Select your option"
                persistent-hint
                :menu-props="{ offsetY: true }"
                return-object
                single-line
              ></v-select>
            </v-flex>
            <div
              v-if="cancelType.value == 'Other’s'"
              class="subheading muted caption"
            >
              Reason
            </div>
            <v-text-field
              class="pt-0 currencyTitle"
              v-if="cancelType.value == 'Other’s'"
              type="text"
              single-line
              label="Enter your reason"
              required
              v-model="cancellationReason"
              :value="cancellationReason"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout>
            <v-btn
              color="primary darken-1"
              text
              @click.native="open3"
              :loading="cancelLoading"
              >Yes</v-btn
            >
            <v-btn color="grey" @click.native="closeCancelAssignment" text
              >Cancel</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="invoiceDialog"
      persistent
      :max-width="500"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark style="background-color: #fee9d0; color: black" flat>
          <v-toolbar-title>{{ headerVatPopup }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="invoiceDialog = false"
              :disabled="loading"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <div style="text-align: center">
            <div class="pb-4">
              <img
                src="../../../assets/ConfirmationPi.svg"
                height="350"
                width="500"
                class="spMargin"
              />
            </div>

            <div>{{ messageVat }}</div>
          </div>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              v-if="vatInfo"
              medium
              style="text-transform: none !important"
              color="red white--text "
              darken-1
              :disabled="loading"
              text
              @click="confirmationPiGenerate('Without VaT')"
              >No</v-btn
            >
            <v-btn
              v-if="!vatInfo"
              color="grey"
              @click="invoiceDialog = false"
              text
              >Cancel</v-btn
            >
            <v-btn
              v-if="!vatInfo"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="generateInvoiceNumber()"
              :disabled="loading"
              text
              >Yes</v-btn
            >
            <v-btn
              v-if="vatInfo"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="confirmationPiGenerate('With VaT')"
              :disabled="loading"
              text
              >Yes</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>
    <!--Cancellation-confirmation-popup---->
    <v-dialog
      v-model="dialog5"
      persistent
      :max-width="450"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          dark
          style="background-color: #fee9d0; color: black; padding-left: 100px"
          flat
        >
          <v-toolbar-title>{{ cancelTitle1 }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="
                dialog5 = false;
                cancelType = '';
                cancellationReason = null;
              "
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text
            style="text-align: center"
            v-show="!!cancelMessage1"
            class="pa-4"
          >
            <div class="pb-4">
              <img
                src="../../../assets/Character-sitting.png"
                height="300"
                width="300"
              />
            </div>
            <div class="subheading">{{ cancelMessage1 }}</div>
            <div
              v-if="cancelType.value == 'Other’s'"
              class="subheading muted pt-2"
            >
              <span style="color: darkgrey">Cancellation reason:</span>
              <p style="word-break: break-all">
                {{ cancelType.value }} - {{ cancellationReason }}
              </p>
            </div>
            <div v-else class="subheading muted pt-2">
              <span style="color: darkgrey">Cancellation reason:</span>
              {{ cancelType.value }}
            </div>
          </v-card-text>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              :loading="cancelLoading"
              text
              @click.native="cancelAssignment"
              >DONE</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogPi"
      persistent
      :max-width="550"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark style="background-color: #fee9d0; color: black" flat>
          <v-toolbar-title> Final Confirmation</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="dialogPi = false"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text class="pa-4">
            {{ ConfirmMessageVat }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="vatInfo"
              medium
              style="text-transform: none !important"
              color="red white--text "
              darken-1
              :disabled="loading"
              text
              @click="dialogPi = false"
              >No</v-btn
            >
            <v-btn
              v-if="!FinalvatApply"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="generateInvoiceNumber(), (vatAmount = 0)"
              :disabled="loading"
              text
              >Yes</v-btn
            >

            <v-btn
              v-if="FinalvatApply"
              medium
              style="text-transform: none !important"
              color="green white--text "
              v-permissions="'generate-purchase-invoice'"
              darken-1
              @click="generateInvoiceNumber()"
              :disabled="loading"
              text
              >Yes</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogMilestoneUnmark"
      persistent
      content-class="milestone-unmark-dialog"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card class="milestone-unmark-card">
        <div class="milestone-unmark-head">
          <span class="milestone-unmark-head__icon">
            <v-icon>remove_done</v-icon>
          </span>
          <div class="milestone-unmark-head__text">
            <strong>Uncheck checkpoint</strong>
            <div class="milestone-unmark-head__chips">
              <span v-if="unmarkMilestoneName">{{ unmarkMilestoneName }}</span>
              <span v-if="unmarkAssignmentId"
                >Assignment {{ unmarkAssignmentId }}</span
              >
            </div>
          </div>
          <v-btn
            icon
            class="milestone-unmark-close"
            @click.prevent="closedUnmarkedMilestonePopup()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <p class="milestone-unmark-body">{{ unmarkMilestoneMessage }}</p>
        <div class="milestone-unmark-actions">
          <v-btn
            flat
            class="milestone-unmark-btn milestone-unmark-btn--ghost"
            :disabled="loading"
            @click="closedUnmarkedMilestonePopup()"
            >No, keep it</v-btn
          >
          <v-btn
            flat
            class="milestone-unmark-btn milestone-unmark-btn--danger"
            :disabled="loading"
            @click="confirmedUnmarkedMilestone()"
            >Yes, uncheck</v-btn
          >
        </div>
      </v-card>
    </v-dialog>

    <!---Asset-ERROR------->
    <v-dialog
      v-model="dialog6"
      persistent
      :max-width="450"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          dark
          style="background-color: #fee9d0; color: black; padding-left: 130px"
          flat
        >
          <v-toolbar-title>{{ errorTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon @click.prevent="closeAssetPopup()">close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text style="text-align: center" class="pa-4">
            <div class="pb-4">
              <img
                src="../../../assets/Character-jumping.svg"
                height="300"
                width="300"
              />
            </div>
            <div class="subheading">{{ errorMessage }}</div>
          </v-card-text>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              @click="closeAssetPopup()"
              :loading="cancelLoading"
              text
              >DONE</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>
    <!--Driver-Error-Popup-->
    <v-dialog
      v-model="dialog7"
      persistent
      :max-width="450"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar
          dark
          style="background-color: #fee9d0; color: black; padding-left: 130px"
          flat
        >
          <v-toolbar-title>{{ errorTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon
              class="heading grey--text text--darken-4"
              @click.prevent="closeOnBoradingPopup()"
              >close</v-icon
            >
          </v-btn>
        </v-toolbar>
        <v-spacer class="spacerclass">
          <v-card-text style="text-align: center" class="pa-4">
            <div class="pb-4">
              <img
                src="../../../assets/Illustrations-groovy.svg"
                height="300"
                width="300"
              />
            </div>
            <div class="subheading">{{ errorMessage }}</div>
          </v-card-text>

          <v-card-actions class="pt-2 pb-5" style="justify-content: center">
            <v-btn
              medium
              style="text-transform: none !important"
              color="orange white--text "
              darken-1
              @click="closeOnBoradingPopup()"
              :loading="cancelLoading"
              text
              >DONE</v-btn
            >
          </v-card-actions>
        </v-spacer>
      </v-card>
    </v-dialog>

    <!-- ADD COMMENT DIALOG -->
    <v-dialog
      v-model="addCommentdialog"
      persistent
      content-class="milestone-comment-dialog"
    >
      <v-form ref="form" onsubmit="return false;">
        <v-card class="milestone-comment-card">
          <div class="milestone-comment-head">
            <span class="milestone-comment-head__icon">
              <v-icon>chat_bubble_outline</v-icon>
            </span>
            <div class="milestone-comment-head__text">
              <strong>Milestone comment</strong>
              <span v-if="milestoneNameById(addCommentCheckListId)">{{
                milestoneNameById(addCommentCheckListId)
              }}</span>
            </div>
            <v-btn icon class="milestone-comment-close" @click="closeAddComment">
              <v-icon>close</v-icon>
            </v-btn>
          </div>

          <div class="milestone-comment-body">
            <span class="milestone-comment-label">Comment</span>
            <v-textarea
              autocomplete="comments"
              class="milestone-comment-input"
              v-model="comments"
              placeholder="Type your comment here"
              rows="4"
              auto-grow
              hide-details
            ></v-textarea>
            <div
              v-show="this.addCommentRes"
              class="milestone-comment-msg milestone-comment-msg--success"
            >
              {{ this.addCommentRes }}
            </div>
            <div
              v-show="this.addCommentx.error"
              class="milestone-comment-msg milestone-comment-msg--error"
            >
              {{ this.addCommentx.error }}
            </div>
          </div>

          <div class="milestone-comment-actions">
            <v-btn
              flat
              class="milestone-comment-btn milestone-comment-btn--ghost"
              @click="closeAddComment"
              >Cancel</v-btn
            >
            <v-btn
              flat
              class="milestone-comment-btn milestone-comment-btn--primary"
              :loading="loading"
              :disabled="loading"
              @click="sendComment"
              >Save comment</v-btn
            >
          </div>
        </v-card>
      </v-form>
    </v-dialog>

    <payment-dialog
      :show="confirmationDialog.makePayment"
      :onClose="() => (confirmationDialog.makePayment = false)"
      :assignmentId="detail.assignmentId"
      :profile="profile"
      :onConfirm="makePayment"
      :paymentAmount="detail.paymentAmount"
      :paymentCurrency="detail.paymentCurrency"
    />
    <success-dialog
      content="Payment successful"
      :show="showPaymentSuccess"
      :onclose="() => (showPaymentSuccess = false)"
    />
    <success-dialog
      :content="x.message"
      :show="x.success"
      :onclose="closeMessage"
    />
    <v-dialog
      v-model="dialog"
      persistent
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card>
        <v-toolbar dark :color="options.color" dense flat>
          <v-toolbar-title class="white--text">{{ title }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text v-show="!!message" class="pa-4">
          {{ message }}
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-btn color="primary darken-1" text @click.native="agree">Yes</v-btn>
          <v-btn color="grey" text @click.native="cancel">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CustomerAdvancePopup
      v-model="customerAdvanceDialog"
      :currency="customerAdvanceCurrency"
      :max-amount="customerAdvanceMax"
      advance-type="assignment"
      :advance-id="detail._id"
      title="Edit Customer Advance"
      message="Do you want to update the customer advance for this shipment?"
      hint="Change the amount, or choose No to keep it as it is."
      yes-text="Update"
      @confirm="onCustomerAdvanceConfirm"
    />
  </div>
</template>

<script>
import JobsProfileDriverAssign from "@/components/Jobs/AssignDriver/JobsProfileDriverAssign";
import jobProfileDriverAssignAir from "@/components/Jobs/AssignDriver/jobProfileDriverAssignAir";
import GenerateAdvance from "@/components/Pop-ups/GenerateAdvance";
import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
import ProofOfDelivery from "@/components/Pop-ups/ProofOfDelivery";
import jobProfileDriverAssignSea from "@/components/Jobs/AssignDriver/jobProfileDriverAssignSea";

import {
  TruckTypes,
  PackingTypes,
  NatureOfCargos,
  JobTypes,
  SeaTypes,
  AirTypes,
} from "../../../constants/constants";
import ErrorBox from "@/components/Common/ErrorBox";
import { EventBus } from "../../../event-bus.js";
import BidResponse from "@/components/Pop-ups/BidResponse";
import moment from "moment";
import {
  getOperatorAmountLabel,
  getOperatorDocumentProofLabel,
} from "@/utils/shipmentLabels";
import ConfirmationDialog from "@/components/Common/ConfirmationDialog";
import PaymentDialog from "@/components/Pop-ups/PaymentDialog";
import SuccessDialog from "@/components/Common/SuccessDialog";
import AddComment from "@/components/Pop-ups/AddComment";
import AddPhysicalDoc from "@/components/Pop-ups/AddPhysicalDoc";
import EditPhysicalDoc from "@/components//Pop-ups/EditPhysicalDoc";
import ViewComment from "@/components/Pop-ups/ViewComment";
import changeMilestone from "../JobDetails/changeMilestone.vue";
import { StorageKeys, CancellationType } from "../../../constants/constants";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.min.css";
import downloadMixin from "@/mixins/downloadMixin";
import CustomerAdvancePopup from "@/components/Common/CustomerAdvancePopup.vue";
import {
  updateAssignmentCustomerAdvance,
  generatePurchaseInvoice,
  driverDocPdf,
  generatePurchaseOrder,
  updateAssignments,
  updateAssignmentsMilestone,
  trackingStatus,
  milestoneList,
  editComment,
  cancelAssignments,
  removeDriver,
  completeAssignments,
  jobsProfileAssignmentList,
} from "../../../constants/api-urls";
export default {
  mixins: [downloadMixin],
  created() {
    this.currentTime();
    this.milestoneItems = this.$props.milestoneItemsList;
    console.log(this.milestoneTrack);
    this.getTrackingStatus();
    this.cancellationType = CancellationType;
    this.$eventBus.$on("open-assign-driver", () => {
      this.checkAssign();
      this.$eventBus.$off("open-assign-driver");
    });
    this.$eventBus.$on("refresh-milstoneChange", () => {
      setTimeout(() => {
        this.getTrackingStatus();
      }, 2000);
      this.status = this.detail.assignmentStatus;
    });
    this.$eventBus.$on("refresh-job", () => {
      console.log(
        "refreshtry",
        this.detail.assignmentStatus,
        this.$props.detail.assignmentStatus
      );
      this.status = this.$props.detail.assignmentStatus;
    });

    this.$eventBus.$on("open-unassign-driver", () => {
      this.checkUnassign();
    });
    this.$eventBus.$on("open-driver-form", () => {
      this.driverpdfDownload();
    });
    this.$eventBus.$on("open-driver-onboarding-form", () => {
      this.driverErrorOpen();
    });
    this.$eventBus.$on(
      "job-driver-assign-success",
      ({ driverId, driverName, assignmentId }) => {
        this.getTrackingStatus();
        this.$emit("updateJobs");

        if (assignmentId !== this.detail.assignmentId) {
          return;
        }

        this.driverId = driverId;
        this.driverName = driverName;
        this.driverAssignModal = false;

        this.$eventBus.$emit("driver-assignment", {
          driverId,
          driverName,
          assignmentId: this.detail.assignmentId,
        });
      }
    );

    this.$eventBus.$on("sales-invoice-assignment", () => {
      setTimeout(() => {
        this.$eventBus.$emit("refresh-job");
      }, 5000);
      console.log("socket coming------");
    });

    this.$eventBus.$on("VASPAK", (data) => {
      console.log("socket receved");
      this.$eventBus.$emit("refresh-job");
    });

    delete this.axios.defaults.headers.common["token"];
    let token = localStorage.getItem(StorageKeys.SessionKey);
    let config = {
      headers: {
        authorization: `bearer ${token}`,
      },
    };
    this.t = config.headers.authorization;
  },

  beforeDestroy() {
    this.$eventBus.$off("job-driver-assign-success");
    this.$eventBus.$off("open-asset-form");
    this.$eventBus.$off("open-driver-onboarding-form");
    this.$eventBus.$off("open-driver-form");
    this.$eventBus.$off("open-unassign-driver");
    this.$eventBus.$off("open-assign-driver");
  },
  props: [
    "working",
    "assetForm",
    "assignments",
    "milestoneItemsList",
    "statusData",
    "jobId",
    "assetId",
    "job",
    "loader",
    "detail",
    "steps",
    "milestoneList",
    "milestoneItemsList",
    "customer",
    "profile",
    "jobType",
    "tabOrder",
    "viewOnly",
  ],
  data() {
    return {
      customerAdvanceDialog: false,
      customerAdvanceCurrency: "",
      customerAdvanceMax: null,
      /* Own flag so saving the advance only busies the SI download button,
         not the PI and other actions that share `loading`. */
      siAdvanceSaving: false,
      dateToday: moment(new Date()).format("YYYY-MM-DD"),
      pickupTime: "",
      confirmation: "",
      valid: true,
      FilterDateBool: false,
      startDate: moment(new Date()).format("YYYY-MM-DD"),
      options: {
        color: "#ffc04c",
        width: 450,
        zIndex: 200,
      },
      invoiceDialog: false,
      dialogPi: false,
      workingCountry: "",
      dialogMilestoneUnmark: false,
      unmarkMilestoneMessage: "",
      unmarkMilestonePopupHeading: "",
      unmarkMilestoneName: "",
      unmarkAssignmentId: "",
      selectedUnmarkCheckpointId: "",
      selectedUnmarkMilestoneId: "",

      operationName: "",
      cancelTitle1: null,
      cancelMessage1: null,
      dialog2: false,
      test1: false,
      cancellationType: [],
      cancelType: "",
      dialog5: false,
      dialog6: false,
      dialog7: false,
      errorMessage: null,
      messageVat: null,
      ConfirmMessageVat: null,
      headerVatPopup: null,
      errorTitle: null,

      options: {
        color: "#ffc04c",
        width: 450,
        zIndex: 1,
      },
      addCommentdialog: false,
      vatAmount: null,
      addCommentRes: "",
      isAddCommentEdit: false,
      addCommentx: {
        error: "",
      },
      addCommentAssId: "",
      addCommentCheckListId: "",
      comments: "",
      readOnly: true,
      natureOfCargos: NatureOfCargos,
      truckTypes: TruckTypes,
      airTypes: AirTypes,
      seaTypes: SeaTypes,
      packingTypes: PackingTypes,
      status: this.detail.assignmentStatus,
      loading: false,
      showPaymentSuccess: false,
      x: {
        message: "",
        loading: false,
        success: false,
      },
      updateInfo: {
        sourceLocation: this.detail.sourceLocation,
        sourceCity: this.detail.sourceCity,
        sourceCountry: this.detail.sourceCountry,
        destinationLocation: this.detail.destinationLocation,
        destinationCity: this.detail.destinationCity,
        destinationCountry: this.detail.destinationCountry,
      },
      milestone: {},
      milestoneItems: [],
      currentMilestoneId: "",
      currentMilestone: 0,
      milestoneTrack: {
        milestone: [],
        assId: null,
      },
      confirmationDialog: {
        cancelAssignment: false,
        makePayment: false,
        completeAssignment: false,
        removeDriverAssignment: false,
        removeTransporterAssignment: false,
      },
      driverAssignModal: false,
      driverId: this.detail.driverId,
      driverName: this.getDriverName(),

      error: null,
      loading: false,
      unassignLoading: false,
      cancelLoading: false,
      cancellationReason: null,
      milestoneArray: [],
      poloading: false,
      vatInfo: false,
      FinalvatApply: false,

      title: null,
      message: null,
      dialog: false,
      dialog3: false,
      statusComments: "",
      options: {
        color: "#ffc04c",
        width: 460,
        zIndex: 200,
      },
    };
  },
  components: {
    BidResponse,
    AddPhysicalDoc,
    EditPhysicalDoc,
    GenerateAdvance,
    JobsProfileDriverAssign,
    jobProfileDriverAssignAir,
    changeMilestone,
    jobProfileDriverAssignSea,
    ErrorBox,
    ConfirmationDialog,
    AddComment,
    ViewComment,
    PaymentDialog,
    SuccessDialog,
    VueTimepicker,
    ProofOfDelivery,
    CustomerAdvancePopup,
  },

  watch: {
    milestoneList(val) {
      this.milestoneItems = val;
    },
  },
  methods: {
    milestoneNameById(id) {
      const list = (this.milestoneTrack && this.milestoneTrack.milestone) || [];
      const found = list.find((m) => m.mileStoneId == id);
      return found ? found.mileStoneName : "";
    },
    getOperatorAmountLabel,
    getOperatorDocumentProofLabel,
    goToProof(_id) {
      this.$router.push(`/documents/${_id}?type=Driver_Proof`);
    },
    refresh() {
      this.$eventBus.$emit("refresh-job");
    },
    hideUnhidePI(val, id) {
      this.loading = true;
      console.log(val, id);

      let url = "/assignments/purchase-invoice-switch";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        assignmentId: id.toString(),
        isPurchaseInvoiceDownloadAllowed: val,
      };

      this.axios.patch(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.refresh();
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        }
      );
    },
    checkLastMilestoneStatus(n) {
      console.log(this.milestoneArray.length, "--length", n);
      if (this.milestoneArray.length === n + 1) {
        return false;
      } else {
        if (!this.milestoneArray[n + 1].isChecked) {
          return true;
        } else {
          return false;
        }
      }
    },
    checkTime() {
      let re = /^\d{1,2}:\d{2}([ap]m)?$/;
      var time = this.pickupTime;

      if (time != "" && !time.match(re)) {
        this.error = "Please select the valid pickup time before moving ahead!";
        time.focus();
        return false;
      }
    },
    currentTime() {
      var currentdate = new Date();
      this.pickupTime = (
        currentdate.getHours() +
        ":" +
        (currentdate.getMinutes() <= 9
          ? "0" + currentdate.getMinutes()
          : currentdate.getMinutes())
      ).toString();
    },
    closeAssetPopup() {
      this.dialog6 = false;
      this.$emit("driverAssetPopUpClosed", false);
    },
    unmarkMilestone(assignId, milestoneID, checkPointId, milestoneName) {
      console.log("true", assignId, milestoneID, checkPointId);

      this.unmarkMilestonePopupHeading = `Uncheck (${milestoneName}) Checkpoint For Assig. Id-${assignId}`;
      this.unmarkMilestoneName = milestoneName;
      this.unmarkAssignmentId = assignId;
      this.unmarkMilestoneMessage = `Are you sure you want to uncheck this checkpoint?  `;
      (this.selectedUnmarkCheckpointId = checkPointId),
        (this.selectedUnmarkMilestoneId = milestoneID),
        (this.dialogMilestoneUnmark = true);
    },

    confirmedUnmarkedMilestone() {
      let url = "/assignments/uncheck-milestone";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        assignmentId: this.detail._id.toString(),
        milestoneId: this.selectedUnmarkMilestoneId,
        checkPointId: this.selectedUnmarkCheckpointId,
      };

      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.getTrackingStatus();
          this.dialogMilestoneUnmark = false;

          this.unmarkMilestonePopupHeading = "";
          this.unmarkMilestoneMessage = "";
          (this.selectedUnmarkCheckpointId = ""),
            (this.selectedUnmarkMilestoneId = "");

          this.$eventBus.$emit("refresh-job");
        },
        (error) => {
          this.dialogMilestoneUnmark = false;

          this.unmarkMilestonePopupHeading = "";
          this.unmarkMilestoneMessage = "";
          (this.selectedUnmarkCheckpointId = ""),
            (this.selectedUnmarkMilestoneId = "");
          this.error = error.response.data.message;
        }
      );
    },
    closedUnmarkedMilestonePopup() {
      this.dialogMilestoneUnmark = false;

      this.unmarkMilestonePopupHeading = "";
      this.unmarkMilestoneMessage = "";
      (this.selectedUnmarkCheckpointId = ""),
        (this.selectedUnmarkMilestoneId = "");
    },
    confirmationPiGenerate(data) {
      console.log(data);
      if (data == "With VaT") {
        console.log("true");
        this.ConfirmMessageVat = "Are you sure you want to apply VAT?";
        this.dialogPi = true;
        this.FinalvatApply = true;
      } else {
        console.log("false");
        this.FinalvatApply = false;
        this.ConfirmMessageVat = "Are you sure you don't want to apply VAT?";
        this.dialogPi = true;
      }
    },

    closeOnBoradingPopup() {
      this.dialog7 = false;
      this.$emit("driverFormPopUpClosed", false);
    },
    closeUnassignPopup() {
      this.$emit("driverUnAssignPopUpClosed", false);
      this.confirmationDialog.removeDriverAssignment = false;
    },
    closeUnassignTransporterPopup() {
      this.$emit("tranporterUnAssignPopUpClosed", false);
      this.confirmationDialog.removeTransporterAssignment = false;
    },

    async checkViewInvoice(
      url,
      isDownloadInvocie,
      isPurchaseInvoviceBackgroundProcess,
      invoiceNumber
    ) {
      this.operationName = "view-purchase-invoice";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        if (!isDownloadInvocie || isPurchaseInvoviceBackgroundProcess) {
          this.loading = false;
          this.error =
            "Purchase Invoice can't be downloaded, background process is ongoing ";
          return;
        }
        /* Mixin function*/
        this.forceDownload(url, "Purchase Invoice" + " " + invoiceNumber);
      } else {
        return;
      }
    },
    async checkViewInvoice2(
      url,
      isDownloadInvocie,
      isPurchaseInvoviceBackgroundProcess,
      invoiceNumber
    ) {
      this.operationName = "view-sales-invoice";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        if (isPurchaseInvoviceBackgroundProcess) {
          this.loading = false;
          this.error =
            "Purchase Invoice can't be downloaded, background process is ongoing ";
          return;
        }
        /* Mixin function*/
        this.forceDownload(url, "Sales Invoice" + " " + invoiceNumber);
      } else {
        return;
      }
    },
    downloadSalesInvoice(url) {
      this.checkViewInvoice2(
        url || this.detail.salesInvoicePdfUrl,
        this.detail.isDownloadInvocie,
        this.detail.isSaleInvoviceBackgroundProcess,
        this.detail.salesInvoiceNumber
      );
    },
    /* For UAE, downloading the assignment level invoice first offers to
       edit its customer advance. Every other country downloads directly. */
    openSalesInvoiceDownload() {
      if (this.working != "UAE") {
        this.downloadSalesInvoice();
        return;
      }
      this.customerAdvanceCurrency =
        this.detail.customerCurrency || this.detail.paymentCurrency || "";
      /* The advance cannot exceed the invoice it is taken off. */
      const invoiceAmount =
        Number(this.detail.invoiceAmount) ||
        Number(this.detail.perAssignmentPrice);
      this.customerAdvanceMax = invoiceAmount > 0 ? invoiceAmount : null;
      this.customerAdvanceDialog = true;
    },
    /* No downloads the current invoice. Update saves the advance, which
       rebuilds the invoice, and downloads the new PDF from the response
       since the cached detail would still point at the old one. */
    onCustomerAdvanceConfirm({ confirmed, amount }) {
      if (!confirmed || amount === null) {
        this.downloadSalesInvoice();
        return;
      }
      this.siAdvanceSaving = true;
      const token = localStorage.getItem(StorageKeys.SessionKey);
      const config = { headers: { authorization: `bearer ${token}` } };
      const body = {
        assignmentId: this.detail._id.toString(),
        customerAdvance: amount,
      };
      delete this.axios.defaults.headers.common["token"];
      this.axios
        .post(
          this.constants.apiUrl + updateAssignmentCustomerAdvance,
          body,
          config
        )
        .then(
          (response) => {
            this.siAdvanceSaving = false;
            const payload = response.data || {};
            const rows = Array.isArray(payload.data) ? payload.data : [];
            /* The response lists every assignment on the invoice. */
            const invoice =
              rows.find((row) => String(row._id) == String(this.detail._id)) ||
              rows[0];
            if (!invoice || !invoice.salesInvoicePdfUrl) {
              this.error =
                "The invoice was updated but its PDF link was not returned. Please try the download again.";
            } else {
              this.downloadSalesInvoice(invoice.salesInvoicePdfUrl);
            }
            this.$eventBus.$emit("refresh-job");
          },
          (error) => {
            this.siAdvanceSaving = false;
            this.error =
              error.response && error.response.data
                ? error.response.data.message
                : "Could not save the customer advance.";
          }
        );
    },
    async generateInvoiceNumber() {
      // this.dialogPi = true;
      this.loading = true;
      this.operationName = "generate-purchase-invoice";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = true;
        let url = "/dmsAdmin/generatePurchaseInvoice";
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let body = { assignmentId: this.detail.assignmentId.toString() };
        if (this.vatAmount > 0) {
          body.vatAmount = this.vatAmount;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.items = response.data.data;
            this.loading = false;

            this.x.success = true;
            this.invoiceDialog = false;
            this.dialogPi = false;

            this.$eventBus.$emit("refresh-job");
          },
          (error) => {
            this.loading = false;
            this.invoiceDialog = false;
            this.dialogPi = false;

            this.error = error.response.data.message;
          }
        );
      } else {
        this.loading = false;
        return;
      }
    },
    async checkCancel() {
      this.operationName = "cancel-assignment-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.confirmationDialog.cancelAssignment = true;
      } else {
        return;
      }
    },
    async checkUnassign() {
      this.operationName = "unassign-driver-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.confirmationDialog.removeDriverAssignment = true;
      } else {
        return;
      }
    },
    async checkUnassignTransporter() {
      this.operationName = "unassign-driver-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.confirmationDialog.removeTransporterAssignment = true;
      } else {
        return;
      }
    },
    async checkAssign() {
      this.operationName = "assign-driver-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.loading = false;
        this.checkCustomer();
      } else {
        return;
      }
    },
    async checkComplete() {
      this.operationName = "complete-assignment-jobs";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.completeAssignment();
      } else {
        return;
      }
    },

    getText(arr = [], val) {
      let finalEl = null;

      finalEl = arr.find((el) => el.value === val.toString());

      return finalEl ? finalEl.text : "NA";
    },
    errorOpen() {
      if (!this.$props.assetId) {
        this.dialog6 = true;
        this.errorTitle = "Error Message";
        this.errorMessage = "Please assign IMEI on the assignment !";
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      } else {
        this.$emit("driverAssetPopUpClosed", false);
        let routeData = this.$router.resolve(
          `/asset/${this.detail.assignmentId}/asset-form`
        );
        window.open(routeData.href, "_blank");
      }
    },
    driverErrorOpen() {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      if (this.status < 2) {
        this.dialog7 = true;
        this.errorTitle = "Error Message";
        this.errorMessage = "Please assign driver on the assignment !";
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      } else {
        this.$emit("driverFormPopUpClosed", false);
        let routeData = this.$router.resolve(
          `/driver/${this.detail.driverData.driverId}/driver-form`
        );
        window.open(routeData.href, "_blank");
      }
    },
    openPiPopup(id) {
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.t = config.headers.authorization;
      let body = {
        assignmentId: id,
      };
      this.axios
        .post(`${this.constants.apiUrl}/dmsAdmin/get-vat-details`, body, config)
        .then((response) => {
          console.log(response.data.data);
          if (response.data.data.amount > 0) {
            this.vatInfo = true;
            this.invoiceDialog = true;
            this.headerVatPopup = "Generate Purchase Invoice With VAT";
            this.messageVat = ` Do you want  to generate Purchase Invoice with  VAT ${
              response.data.data.vatPercent
            } % (${response.data.data.amount.toFixed(2)} ${
              response.data.data.currency
            }) ?`;
            this.vatAmount = response.data.data.amount;
          } else {
            this.invoiceDialog = true;
            this.vatInfo = false;

            this.headerVatPopup = "Generate Purchase Invoice";
            this.messageVat = ` Do you want to generate Purchase Invoice ?`;
          }
        });

      this.cancelloading = false;
      this.loading = false;

      // console.log(id)

      //  this.cancelloading = false;  this.loading = false;
    },

    driverpdfDownload() {
      this.$eventBus.$emit("on-load");
      let url = "/dmsAdmin/driverDocPdf";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { driverId: this.detail.driverData.driverId };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.loading = false;
          this.$eventBus.$emit("off-load");
          const a = document.createElement("a");
          a.style.display = "none";
          document.body.appendChild(a);
          this.$emit("driverPdfPopUpClosed", false);
          // Set the HREF to a Blob representation of the data to be downloaded
          a.href = response.data.data;
          a.download = "documents" + this.detail.driverData.driverId;
          a.target = "_blank";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(a.href);
          document.body.removeChild(a);
        },
        (error) => {
          this.loading = false;
          this.$eventBus.$emit("off-load");
          this.error = error.response.data.message;
        }
      );
    },
    open3(val, index) {
      if (!navigator.onLine) {
        this.loading = false;
        this.error = "Please check your internet connection";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return;
      }
      if (!this.cancelType) {
        this.error = "Please select cancellation reason before moving ahead";
        setTimeout(() => {
          this.x.error = "";
        }, 3000);
        return false;
      }
      if (this.cancelType.value == "Other’s") {
        if (!this.cancellationReason) {
          this.error = "Please enter cancellation reason before moving ahead";
          setTimeout(() => {
            this.x.error = "";
          }, 3000);
          return false;
        }
      }
      this.confirmationDialog.cancelAssignment = false;
      this.dialog5 = true;
      this.cancelTitle1 = "Cancellation Message";
      this.cancelMessage1 = "Your job has been cancelled!";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    cancel3() {
      this.resolve(false);
      this.dialog5 = false;
    },
    test() {
      ut = milestone.milestoneId;
    },
    getTime(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    getTimes(date) {
      return moment(date).format("ll LT");
    },
    getDate(date) {
      return moment(date).format("ll");
    },
    retryPO(assignId) {
      this.poloading = true;
      let url = "/dmsAdmin/generatePurchaseOrder";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = { assignId: assignId.toString() };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.poloading = false;
          this.$eventBus.$emit("update-po");
          this.$eventBus.$emit("refresh-job");
          setTimeout(() => (this.dialog = false), 100);
        },
        (error) => {
          this.poloading = false;
          this.error = error.response.data.message;
        }
      );
    },
    openMilestone() {
      this.dialog3 = true;
      this.title = "Are you sure?";
      this.message = "Click yes to select milestone , cancel to go back";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.loading = true;
        this.reject = reject;
      });
    },
    selectMilestone() {
      let url = "/dmsAdmin/updateAssignMents";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        assId: this.detail.assignmentId.toString(),
        milestoneId: this.milestone,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.dialog3 = false;
          this.$eventBus.$emit("refresh-job");
          this.getTrackingStatus();
        },
        (error) => {
          this.error = error.response.data.message;
        }
      );
    },
    cancel3() {
      this.milestone = "";
      this.resolve(false);
      this.dialog3 = false;
    },
    openInfoMilestone(mileStoneId, n) {
      this.loading = false;

      if (this.detail.assignmentStatus === 1) {
        this.error = "Please assign the driver";
        return;
      }
      this.currentMilestoneId = mileStoneId;

      this.dialog2 = true;
      this.startDate = moment(new Date()).format("YYYY-MM-DD");
      this.currentTime();
      this.title = "Are you sure? ";
      this.message = "Click yes update milestone , cancel to go back";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    updateMilestone(assId, checkListId) {
      if (this.loading) {
        return;
      } else {
        if (this.startDate) {
          if (!this.pickupTime) {
            this.error = "Please select actual milestone time!";
            return;
          } else {
            this.checkTime();

            let currentDate = moment(new Date()).format("YYYY-MM-DD, HH:mm");
            let selectedDateTime = this.startDate + "," + this.pickupTime;

            if (
              new Date(currentDate).getTime() <
              new Date(selectedDateTime).getTime()
            ) {
              this.loading = false;
              this.error =
                "Please select the past pickup time and date before moving ahead!";
              return false;
            }
          }
        }

        this.loading = true;
        this.addCommentAssId = assId;
        this.addCommentCheckListId = checkListId;
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };
        let url = "/dmsAdmin/updateAssignMilestone";
        let body = {
          assId: this.addCommentAssId,
          checkListId: this.addCommentCheckListId,
          comments: "",
        };
        if (this.startDate && this.pickupTime) {
          body.updatedAt = moment.utc(
            new Date(this.startDate + "," + this.pickupTime)
          );
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.dialog2 = false;

            this.$eventBus.$emit("milestoneChecked-completed");

            if (
              this.milestoneTrack.milestone.length ==
              this.detail.completedCheckList.length
            ) {
              this.status = 6;
            }
            if (
              this.milestoneTrack.milestone.length ==
              this.detail.completedCheckList.length + 1
            ) {
              this.status = 6;
            } else {
              this.status = 5;
            }
            this.loading = false;
            this.addCommentCheckListId = "";
            this.addCommentAssId = "";
            this.comments = "";
            this.addCommentdialog = false;
            this.isAddCommentEdit = false;
            this.milestoneItems = response.data.data;
            this.componentKey += 1;
            this.getTrackingStatus();
            // No delayed close/reset here: a timer would close (or overwrite
            // the date/time of) the next milestone's dialog if it is opened
            // within a second or two. openInfoMilestone resets the fields.
            this.res = "";
          },
          (error) => {
            this.loading = false;
            this.addCommentx.error = "Unable to update milestone.";
            this.error = error.response.data.message;
          }
        );
      }
    },
    cancel1() {
      this.startDate = moment(new Date()).format("YYYY-MM-DD");
      this.currentTime();
      this.FilterDateBool = false;
      this.resolve(false);
      this.dialog2 = false;
      this.loading = false;
    },

    open() {
      this.dialog = true;
      this.title = "Customer's Documents";
      this.message =
        "Customer's documentation is not complete. Are you sure you want to proceed?";
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.driverAssignModal = true;
      this.dialog = false;
    },
    cancel() {
      this.$emit("driverAssignPopUpClosed", false);
      this.resolve(false);
      this.dialog = false;
    },
    checkCustomer() {
      if (
        this.customer.passPort &&
        this.customer.visa &&
        this.customer.emiratesId &&
        this.customer.vatCertificate &&
        this.customer.tradeLicense
      ) {
        "/job/assign-driver" + "?user=" + localStorage.getItem("user");
        this.driverAssignModal = true;
      } else {
        this.open();
      }
    },
    closeMessage() {
      this.x.success = false;
      this.componentKey += 1;
      this.getTrackingStatus();
    },
    getTrackingStatus() {
      this.$eventBus.$emit("on-load");
      let url = "/dmsAdmin/trackingStatus";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let assignmentId = this.detail.assignmentId.toString();
      let body = {
        assId: assignmentId,
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.$eventBus.$emit("off-load");
          this.milestoneArray = response.data.data;
          this.milestoneTrack.milestone = response.data.data;

          for (
            let index = 0;
            index < this.milestoneTrack.milestone.length;
            index++
          ) {
            if (!this.milestoneTrack.milestone[index].isChecked) {
              this.currentMilestone = index;
              break;
            }
          }
          this.milestoneTrack.assId = assignmentId;
        },
        (error) => {
          this.$eventBus.$emit("off-load");
          this.error = "Failed to Fetch Milestone Status";
        }
      );
    },
    getMilestones() {
      let url = "/dmsAdmin/milestoneList";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      let body = {
        workingCountry: [this.$props.working],
        assignDriver: "true",
      };
      this.axios.post(this.constants.apiUrl + url, body, config).then(
        (response) => {
          this.milestoneItems = response.data.data;
        },
        (error) => {
          this.error = "Failed to Fetch Milestone Status";
        }
      );
    },
    closeAddComment() {
      this.isAddCommentEdit = false;
      this.comments = "";
      this.addCommentdialog = false;
      this.addCommentAssId = "";
      this.addCommentCheckListId = "";
    },
    editMilestoneComment(assId, checkListId, index) {
      this.isAddCommentEdit = true;
      this.comments = this.milestoneTrack.milestone[index].comments;
      this.addCommentdialog = true;
      this.addCommentAssId = assId;
      this.addCommentCheckListId = checkListId;
    },
    sendComment() {
      if (this.loading) {
        return;
      } else {
        delete this.axios.defaults.headers.common["token"];
        let token = localStorage.getItem(StorageKeys.SessionKey);
        let config = {
          headers: {
            authorization: `bearer ${token}`,
          },
        };

        this.loading = true;
        let url = editComment;
        let body = {
          assignmentId: this.addCommentAssId,
          milestoneId: this.addCommentCheckListId,
        };

        if (this.comments.trim()) {
          body.comments = this.comments.trim();
        } else {
          this.addCommentx.error =
            "Please provide a comment before moving ahead.";
          this.loading = false;
          return false;
        }
        this.axios.post(this.constants.apiUrl + url, body, config).then(
          (response) => {
            this.loading = false;
            this.addCommentCheckListId = "";
            this.addCommentAssId = "";
            this.comments = "";
            this.addCommentdialog = false;
            this.isAddCommentEdit = false;
            this.milestoneItems = response.data.data;
            this.x.success = "Milestone Updated";
            this.componentKey += 1;
            this.getTrackingStatus();
            this.res = "";
          },
          (error) => {
            // Reset so Submit works again after a failed save.
            this.loading = false;
            this.addCommentx.error = "Unable to update milestone.";
          }
        );
      }
    },

    getDriverName() {
      return this.detail.driverFirstName
        ? this.detail.driverFirstName + " " + this.detail.driverLastName
        : "NA";
    },
    getStatus(status) {
      switch (status) {
        case 1:
          return "Driver Not Assigned";
        case 2:
          return "Driver Assigned";
        case 3:
          return "Payment Pending";
        case 4:
          return "Payment Done";
        case 5:
          return "In-Transit";
        case 6:
          return "Shipment Offloaded";

        case -1:
          return "Cancelled";
        default:
          return "Unknown";
      }
    },
    getText(arr = [], val, type) {
      let finalEl = null;
      if (type === "trucktype")
        finalEl = arr.find((el) => el.value === val.toString());
      else {
        finalEl = arr.find((el) => el.value === val);
      }
      return finalEl ? finalEl.text : "NA";
    },
    getLocation(...arr) {
      return arr
        ? arr
            .filter((val) => val !== undefined)
            .reduce((prev, curr) => prev + ", " + curr)
        : "NA";
    },
    cancelAssignment() {
      this.cancelLoading = true;
      let url = cancelAssignments;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const data = {
        assignmentId: this.detail.assignmentId.toString(),
      };
      if (this.cancelType.value) {
        if (this.cancelType.value == "Other’s") {
          data.cancellationReason =
            this.cancelType.value + " - " + this.cancellationReason;
        } else {
          data.cancellationReason = this.cancelType.value;
        }
      }

      this.axios.post(this.constants.apiUrl + url, data, config).then(
        (response) => {
          this.$eventBus.$emit("cancelled");
          this.cancelLoading = false;
          this.dialog5 = false;
          this.status = -1;
          this.closeCancelAssignment();
        },
        (error) => {
          this.cancelLoading = false;
          this.error = this.$eventBus.parse(error);
        }
      );
    },
    closeCancelAssignment() {
      this.cancellationReason = null;
      this.confirmationDialog.cancelAssignment = false;
      this.cancelType = "";
    },
    reset() {
      this.readOnly = true;
      this.updateInfo = Object.assign(
        {},
        {
          sourceLocation: this.detail.sourceLocation,
          sourceCity: this.detail.sourceCity,
          sourceCountry: this.detail.sourceCountry,
          destinationLocation: this.detail.destinationLocation,
          destinationCity: this.detail.destinationCity,
          destinationCountry: this.detail.destinationCountry,
        }
      );
    },
    updateLocation() {
      this.loading = true;
      const { assignmentId } = this.detail;
      const {
        sourceLocation,
        sourceCity,
        sourceCountry,
        destinationLocation,
        destinationCity,
        destinationCountry,
      } = this.updateInfo;

      this.axios
        .post(`${this.constants.serverUrl}/api/assignments/update`, {
          assignmentId,
          sourceLocation,
          sourceCity,
          sourceCountry,
          destinationLocation,
          destinationCity,
          destinationCountry,
        })
        .then(
          (response) => {
            const { status, data } = response.data;
            this.updateInfo = Object.assign(
              {},
              {
                sourceLocation,
                sourceCity,
                sourceCountry,
                destinationLocation,
                destinationCity,
                destinationCountry,
              }
            );
            this.loading = false;
            this.readOnly = true;
          },
          (error) => {
            this.error = this.$eventBus.parse(error);
            this.loading = false;
          }
        );
    },
    changeLocation() {
      this.error = null;
      const {
        sourceLocation,
        sourceCity,
        sourceCountry,
        destinationLocation,
        destinationCity,
        destinationCountry,
      } = this.detail;
      this.updateInfo = Object.assign(
        {},
        {
          sourceLocation,
          sourceCity,
          sourceCountry,
          destinationLocation,
          destinationCity,
          destinationCountry,
        }
      );
      this.readOnly = false;
    },
    completeAssignment() {
      this.error = null;
      this.loading = true;
      const { serverUrl } = this.constants;
      let url = completeAssignments;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const data = {
        assignmentId: this.detail.assignmentId.toString(),
      };

      //  this.$eventBus.$emit("assignment-completed");
      this.axios.post(this.constants.apiUrl + url, data, config).then(
        (response) => {
          const { status } = response.data;
          this.$eventBus.$emit("assignment-completed");
          this.status = 3;
          this.loading = false;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.loading = false;
        }
      );
    },
    onDriverAssign({ driverId, driverName }) {
      if (this.detail.completedCheckList.length) {
        this.status = 5;
      } else {
        this.status = 2;
      }
      this.driverId = driverId;
      this.driverName = driverName;
    },
    removeDriverAssignment() {
      if (!this.driverId) {
        return;
      }
      this.unassignLoading = true;

      let url = removeDriver;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const data = {
        driverId: this.driverId.toString(),
        assignmentId: this.detail.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, data, config).then(
        (response) => {
          this.$eventBus.$emit("unassigned-completed");

          this.status = 1;
          this.driverId = null;
          this.driverName = null;
          this.unassignLoading = false;
          this.confirmationDialog.removeDriverAssignment = false;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.unassignLoading = false;
        }
      );
    },
    removeTransporterAssignment() {
      if (
        this.detail.assignmentStatus == 2 ||
        this.detail.assignmentStatus == 5 ||
        this.detail.assignmentStatus == 6
      ) {
        this.error = "Please unassign the driver first !";
        this.unassignLoading = false;
        return;
      }
      this.unassignLoading = true;
      let url = "/dmsAdmin/unassignTransporter";
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      const data = {
        assignmentId: this.detail.assignmentId.toString(),
      };
      this.axios.post(this.constants.apiUrl + url, data, config).then(
        (response) => {
          this.$eventBus.$emit("unassigned-completed");
          this.status = 1;
          this.driverId = null;
          this.driverName = null;
          this.unassignLoading = false;
          this.confirmationDialog.removeTransporterAssignment = false;
        },
        (error) => {
          this.error = this.$eventBus.parse(error);
          this.unassignLoading = false;
        }
      );
    },
    makePayment() {
      this.status = 4;
      this.confirmationDialog.makePayment = false;
      this.showPaymentSuccess = true;
    },
  },
};
</script>
<style lang="scss">
.fonttime {
  font-size: 15px;
}
.fonttime .dropdown.drop-down {
  top: -14%;
}
.pa-38 {
  padding: 38px;
}
div ::-webkit-scrollbar-thumb {
  background: #ea7a1c;
}
div ::-webkit-scrollbar {
  width: 10px;
}
.active {
  background-color: #ea7a1c !important;
}

.assignment-detail-panel {
  --assignment-bg: #f4f6fa;
  --assignment-panel: #ffffff;
  --assignment-border: #e1e7f0;
  --assignment-ink: #172033;
  --assignment-muted: #667085;
  --assignment-soft: #fff7ed;
  --assignment-orange: #f58220;
  --assignment-orange-dark: #a85510;
  background: #f8fafc;
  border-top: 1px solid var(--assignment-border);
  max-height: none;
  overflow: hidden;
  overscroll-behavior: contain;
  padding: 10px;
  scrollbar-gutter: stable;
}

.assignment-detail-card {
  background: var(--assignment-panel) !important;
  border: 1px solid var(--assignment-border) !important;
  border-radius: 12px !important;
  box-shadow: 0 14px 30px rgba(23, 32, 51, 0.07) !important;
  overflow: hidden;
}

.assignment-detail-body {
  background: var(--assignment-bg);
  padding: 10px !important;
}

.assignment-detail-panel .v-alert {
  border-radius: 10px !important;
  margin-bottom: 12px;
}

.assignment-detail-panel .heading.orange--text {
  color: var(--assignment-ink) !important;
  font-size: 16px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  padding-bottom: 12px !important;
}

.assignment-detail-toolbar {
  align-items: center;
  background: #ffffff;
  border: 1px solid var(--assignment-border);
  border-radius: 12px;
  margin-bottom: 10px;
  padding: 9px 12px;
  position: sticky;
  top: 0;
  z-index: 6;
}

.assignment-detail-panel > .v-card,
.assignment-detail-panel .v-card {
  border-radius: 12px;
}

.assignment-milestone-board {
  background:
    linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%),
    #ffffff;
  border: 1px solid var(--assignment-border);
  border-radius: 14px;
  display: block;
  margin-bottom: 10px;
  max-width: none !important;
  overflow-x: hidden;
  padding: 12px;
  position: relative;
  scrollbar-gutter: stable;
}

.assignment-milestone-board::before {
  background: linear-gradient(90deg, #fed7aa, #e1e7f0);
  border-radius: 999px;
  content: "";
  height: 3px;
  left: 38px;
  position: absolute;
  right: 38px;
  top: 46px;
}

.assignment-detail-panel .assignment-milestone-flow {
  background: transparent !important;
  box-shadow: none !important;
  position: relative;
  width: 100%;
}

.assignment-detail-panel .assignment-milestone-track {
  align-items: stretch;
  background: transparent !important;
  box-shadow: none !important;
  display: flex;
  gap: 8px;
  min-height: 122px !important;
  padding: 0;
}

.assignment-detail-panel .assignment-milestone-card.v-stepper__step {
  align-items: flex-start !important;
  background: #ffffff !important;
  border: 1px solid var(--assignment-border) !important;
  border-radius: 14px !important;
  box-shadow: 0 10px 24px rgba(23, 32, 51, 0.05) !important;
  color: var(--assignment-ink) !important;
  flex: 0 0 220px !important;
  margin: 0 !important;
  min-height: 110px !important;
  min-width: 220px !important;
  overflow: hidden;
  padding: 12px 12px 12px 44px !important;
  position: relative !important;
}

.assignment-detail-panel
  .assignment-milestone-card.v-stepper__step
  .v-stepper__step__step {
  background: #ffffff !important;
  border: 2px solid #d0d5dd !important;
  box-shadow: 0 0 0 5px #f8fafc;
  color: var(--assignment-muted) !important;
  font-size: 12px !important;
  font-weight: 900 !important;
  height: 24px !important;
  left: 12px;
  margin: 0 !important;
  position: absolute;
  top: 13px;
  width: 24px !important;
}

.assignment-detail-panel .assignment-milestone-card--done.v-stepper__step {
  background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 74%) !important;
  border-color: #bbf7d0 !important;
}

.assignment-detail-panel
  .assignment-milestone-card--done.v-stepper__step
  .v-stepper__step__step {
  background: #16a66a !important;
  border-color: #16a66a !important;
  box-shadow: 0 0 0 5px #dcfce7;
  color: #ffffff !important;
}

.assignment-detail-panel .assignment-milestone-card--active.v-stepper__step {
  background: linear-gradient(180deg, #fff7ed 0%, #ffffff 76%) !important;
  border-color: #fed7aa !important;
  box-shadow: 0 14px 30px rgba(245, 130, 32, 0.16) !important;
}

.assignment-detail-panel
  .assignment-milestone-card--active.v-stepper__step
  .v-stepper__step__step {
  background: var(--assignment-orange) !important;
  border-color: var(--assignment-orange) !important;
  box-shadow: 0 0 0 5px #ffedd5;
  color: #ffffff !important;
}

.assignment-detail-panel .assignment-milestone-card--pending.v-stepper__step {
  background: #ffffff !important;
}

.assignment-detail-panel .assignment-milestone-card .v-stepper__label {
  display: block !important;
  width: 100%;
}

.assignment-milestone-card__top {
  align-items: center;
  display: flex;
  justify-content: space-between;
  min-height: 26px;
}

.assignment-milestone-badge {
  background: #eef2f7;
  border-radius: 999px;
  color: #475467;
  display: inline-flex;
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0;
  line-height: 1;
  padding: 7px 9px;
  text-transform: uppercase;
}

.assignment-milestone-card--done .assignment-milestone-badge {
  background: #dcfce7;
  color: #047857;
}

.assignment-milestone-card--active .assignment-milestone-badge {
  background: #ffedd5;
  color: var(--assignment-orange-dark);
}

.assignment-milestone-title {
  color: var(--assignment-ink);
  display: block;
  font-size: 14px;
  font-weight: 900;
  line-height: 1.32;
  margin-top: 10px;
  overflow-wrap: anywhere;
}

.assignment-milestone-meta,
.assignment-milestone-hint {
  align-items: center;
  color: var(--assignment-muted);
  display: flex;
  font-size: 11px;
  font-weight: 800;
  gap: 5px;
  line-height: 1.35;
  margin-top: 7px;
  overflow-wrap: anywhere;
  white-space: normal;
}

.assignment-milestone-meta .v-icon {
  color: #98a2b3 !important;
  font-size: 14px !important;
}

.assignment-milestone-reverse {
  background: #fef3f2;
  border-radius: 999px;
  color: #b42318 !important;
  cursor: pointer;
  font-size: 17px !important;
  padding: 4px;
}

.assignment-detail-panel .assignment-milestone-comment.viewDetail {
  align-items: center;
  display: inline-flex;
  font-size: 17px !important;
  height: 30px;
  justify-content: center;
  margin-top: 10px;
  width: 30px;
}

.assignment-detail-panel .assignment-milestone-divider {
  align-self: center;
  background: #fed7aa !important;
  border-radius: 999px;
  flex: 0 0 34px !important;
  height: 2px !important;
  margin: 0 !important;
  min-width: 34px !important;
  width: 34px !important;
}

.assignment-detail-panel .my-1.mb-4 {
  border-color: var(--assignment-border) !important;
  margin-bottom: 16px !important;
}

.assignment-detail-panel .py-4.layout.row,
.assignment-detail-panel .layout.row.py-4,
.assignment-detail-panel v-layout.py-4 {
  align-items: stretch;
  display: grid !important;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 0 !important;
}

.assignment-detail-panel .layout.row.py-4 > .flex,
.assignment-detail-panel .py-4.layout.row > .flex {
  background: #ffffff;
  border: 1px solid var(--assignment-border);
  border-radius: 10px;
  flex-basis: auto !important;
  max-width: none !important;
  min-height: 62px;
  padding: 10px !important;
  width: auto !important;
}

.assignment-detail-panel .subheading.muted {
  color: var(--assignment-muted) !important;
  font-size: 11px !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  text-transform: uppercase;
}

.assignment-detail-panel .heading {
  color: var(--assignment-ink);
  font-size: 13px;
  font-weight: 900;
  line-height: 1.4;
  overflow-wrap: anywhere;
}

.assignment-detail-panel .v-btn,
.assignment-detail-panel button,
.assignment-detail-panel .track-ass-btn,
.assignment-detail-panel .download-ass-btn,
.assignment-detail-panel .orange-button,
.assignment-detail-panel .assignment-dialog-submit-btn {
  border-radius: 8px !important;
  box-shadow: none !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  min-height: 34px;
  text-transform: none !important;
}

.assignment-detail-panel .track-ass-btn,
.assignment-detail-panel .orange-button,
.assignment-detail-panel .assignment-dialog-submit-btn {
  background: var(--assignment-orange) !important;
  color: #ffffff !important;
}

.assignment-detail-panel .assignment-dialog-submit-btn .v-btn__content {
  color: #ffffff !important;
}

.assignment-detail-panel .viewDetail {
  background: #eef4ff;
  border-radius: 999px;
  color: #3157d5 !important;
  margin-top: 8px;
  padding: 5px;
}

.assignment-detail-panel {
  background: #ffffff;
  max-height: none;
  padding: 8px;
}

.assignment-detail-card {
  border-radius: 8px !important;
  box-shadow: none !important;
}

.assignment-detail-body {
  background: #ffffff;
  padding: 8px !important;
}

.assignment-detail-toolbar {
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 7px 10px;
}

.assignment-milestone-board {
  background: #ffffff;
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 8px;
}

.assignment-milestone-board::before {
  display: none;
}

.assignment-detail-panel .assignment-milestone-track {
  gap: 6px;
  min-height: 88px !important;
}

.assignment-detail-panel .assignment-milestone-card.v-stepper__step {
  border-radius: 8px !important;
  box-shadow: none !important;
  flex: 0 0 176px !important;
  min-height: 82px !important;
  min-width: 176px !important;
  padding: 9px 9px 9px 36px !important;
}

.assignment-detail-panel
  .assignment-milestone-card.v-stepper__step
  .v-stepper__step__step {
  box-shadow: none;
  font-size: 11px !important;
  height: 20px !important;
  left: 9px;
  top: 10px;
  width: 20px !important;
}

.assignment-milestone-card__top {
  min-height: 20px;
}

.assignment-milestone-badge {
  border-radius: 6px;
  font-size: 9px;
  padding: 5px 7px;
}

.assignment-milestone-title {
  font-size: 12px;
  line-height: 1.25;
  margin-top: 6px;
}

.assignment-milestone-meta,
.assignment-milestone-hint {
  font-size: 10px;
  line-height: 1.25;
  margin-top: 4px;
}

.assignment-milestone-reverse {
  font-size: 14px !important;
  padding: 3px;
}

.assignment-detail-panel .assignment-milestone-comment.viewDetail {
  font-size: 14px !important;
  height: 24px;
  margin-top: 6px;
  width: 24px;
}

.assignment-detail-panel .assignment-milestone-divider {
  flex-basis: 18px !important;
  min-width: 18px !important;
  width: 18px !important;
}

.assignment-detail-panel .py-4.layout.row,
.assignment-detail-panel .layout.row.py-4,
.assignment-detail-panel v-layout.py-4 {
  gap: 0;
}

.assignment-detail-panel .layout.row.py-4 > .flex,
.assignment-detail-panel .py-4.layout.row > .flex {
  border: 0;
  border-bottom: 1px solid #eef2f7;
  border-radius: 0;
  border-right: 1px solid #eef2f7;
  min-height: 46px;
  padding: 7px 9px !important;
}

.assignment-detail-panel {
  background: #fbfcfe;
  border-top: 1px solid #e7ebf2;
  max-height: none;
  padding: 0;
}

.assignment-detail-card {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.assignment-detail-body {
  background: transparent;
  padding: 7px 9px !important;
}

.assignment-detail-toolbar {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e7ebf2;
  border-radius: 0;
  margin: -7px -9px 7px;
  min-height: 34px;
  padding: 5px 9px;
}

.assignment-detail-panel .heading.orange--text {
  color: #111827 !important;
  font-size: 12px !important;
  line-height: 1.15;
  padding-bottom: 0 !important;
}

.assignment-milestone-board {
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e7ebf2;
  border-radius: 0;
  margin: 0 0 7px;
  overflow-x: hidden;
  padding: 5px 0 8px;
}

.assignment-detail-panel .assignment-milestone-track {
  align-items: flex-start;
  gap: 0;
  min-height: 74px !important;
  overflow: hidden;
  padding: 0 4px;
  position: relative;
}

.assignment-detail-panel .assignment-milestone-track::before {
  background: #dfe4ec;
  content: "";
  height: 2px;
  left: 18px;
  position: absolute;
  right: 18px;
  top: 12px;
}

.assignment-detail-panel .assignment-milestone-card.v-stepper__step {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  flex: 0 0 148px !important;
  min-height: 68px !important;
  min-width: 148px !important;
  padding: 25px 6px 0 !important;
  text-align: left;
}

.assignment-detail-panel
  .assignment-milestone-card.v-stepper__step
  .v-stepper__step__step {
  background: #ffffff !important;
  border: 2px solid #cfd6e2 !important;
  box-shadow: none;
  color: #6b7280 !important;
  font-size: 10px !important;
  height: 20px !important;
  left: 6px;
  top: 3px;
  width: 20px !important;
  z-index: 2;
}

.assignment-detail-panel
  .assignment-milestone-card--done.v-stepper__step
  .v-stepper__step__step {
  background: #16a66a !important;
  border-color: #16a66a !important;
  color: #ffffff !important;
}

.assignment-detail-panel
  .assignment-milestone-card--active.v-stepper__step
  .v-stepper__step__step {
  background: #f58220 !important;
  border-color: #f58220 !important;
  color: #ffffff !important;
}

.assignment-detail-panel .assignment-milestone-card--done.v-stepper__step,
.assignment-detail-panel .assignment-milestone-card--active.v-stepper__step,
.assignment-detail-panel .assignment-milestone-card--pending.v-stepper__step {
  background: transparent !important;
  border: 0 !important;
}

.assignment-milestone-card__top {
  display: block;
  min-height: 0;
}

.assignment-milestone-badge {
  background: transparent;
  border-radius: 0;
  color: #7a8494;
  display: block;
  font-size: 8px;
  line-height: 1.1;
  padding: 0;
}

.assignment-milestone-card--done .assignment-milestone-badge {
  background: transparent;
  color: #047857;
}

.assignment-milestone-card--active .assignment-milestone-badge {
  background: transparent;
  color: #b45309;
}

.assignment-milestone-title {
  color: #111827;
  font-size: 11px;
  line-height: 1.16;
  margin-top: 3px;
}

.assignment-milestone-meta,
.assignment-milestone-hint {
  color: #7a8494;
  font-size: 9px;
  gap: 3px;
  line-height: 1.15;
  margin-top: 3px;
}

.assignment-detail-panel .assignment-milestone-comment.viewDetail,
.assignment-milestone-reverse {
  background: transparent;
  height: auto;
  margin-top: 3px;
  padding: 0;
  width: auto;
}

.assignment-detail-panel .assignment-milestone-divider {
  background: transparent !important;
  flex-basis: 0 !important;
  min-width: 0 !important;
  width: 0 !important;
}

.assignment-detail-panel .my-1.mb-4 {
  display: none !important;
}

.assignment-detail-panel .py-4.layout.row,
.assignment-detail-panel .layout.row.py-4,
.assignment-detail-panel v-layout.py-4 {
  border-top: 1px solid #e7ebf2;
  gap: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.assignment-detail-panel .layout.row.py-4 > .flex,
.assignment-detail-panel .py-4.layout.row > .flex {
  background: transparent;
  display: grid !important;
  gap: 2px 7px;
  grid-template-columns: minmax(92px, 0.45fr) minmax(0, 1fr);
  min-height: 30px;
  padding: 5px 8px !important;
}

.assignment-detail-panel .subheading.muted {
  font-size: 9px !important;
  line-height: 1.15;
}

.assignment-detail-panel .heading {
  font-size: 11px;
  line-height: 1.22;
}

@media (max-width: 1180px) {
  .assignment-detail-panel .py-4.layout.row,
  .assignment-detail-panel .layout.row.py-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .assignment-detail-panel {
    padding: 10px;
  }

  .assignment-detail-panel .py-4.layout.row,
  .assignment-detail-panel .layout.row.py-4 {
    grid-template-columns: 1fr;
  }
}

.vue__time-picker input.display-time {
  border-radius: 0px !important;
  border-bottom: 1px solid #d2d2d2 !important;
  border: none;
  padding: 0px !important;
}

.assignment-detail-panel,
.assignment-detail-card,
.assignment-detail-body,
.assignment-milestone-board,
.assignment-detail-panel .assignment-milestone-flow,
.assignment-detail-panel .assignment-milestone-track {
  max-height: none !important;
  overflow: hidden !important;
}

.assignment-detail-panel {
  width: 100%;
}

.assignment-detail-panel .assignment-milestone-board {
  overflow-x: hidden !important;
}

.assignment-detail-panel .assignment-milestone-track {
  flex-wrap: nowrap;
  width: 100%;
}

.assignment-detail-panel .assignment-milestone-card.v-stepper__step {
  flex: 1 1 0 !important;
  min-width: 0 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar {
  align-items: center;
  display: flex !important;
  gap: 0.5rem;
  overflow: visible !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar > .heading {
  flex: 1 1 auto;
  min-width: 0;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar > .spacer {
  display: none;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar .v-btn,
.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar button {
  height: 2.125rem !important;
  flex: 0 0 auto;
  font-size: 0.75rem !important;
  line-height: 1 !important;
  max-width: 100%;
  min-height: 2.125rem !important;
  min-width: 0;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap !important;
}

.job-dossier--modern .assignment-detail-panel .py-4.layout.row,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 {
  align-items: stretch;
  border-top: 1px solid #e7ebf2;
  display: grid !important;
  gap: 0;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  overflow: hidden;
  padding: 0 !important;
  width: 100%;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > .flex,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > .flex,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div > .flex,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div > .flex,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div {
  background: transparent;
  border-bottom: 1px solid #eef2f7;
  border-right: 1px solid #eef2f7;
  box-sizing: border-box;
  display: flex !important;
  flex-basis: auto !important;
  flex-direction: column;
  gap: 0.375rem;
  justify-content: flex-start;
  max-width: none !important;
  min-height: 3.5rem;
  min-width: 0 !important;
  padding: 0.625rem 0.75rem !important;
  width: auto !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div > .flex,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div > .flex {
  border: 0 !important;
  min-height: 0;
  padding: 0 !important;
  width: 100% !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > .flex:empty,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > .flex:empty,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div:empty,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div:empty {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .subheading.muted,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .subheading.muted,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .subheading.muted {
  color: #777166 !important;
  display: block;
  font-size: 0.6875rem !important;
  font-weight: 900 !important;
  letter-spacing: 0 !important;
  line-height: 1.2;
  margin: 0 !important;
  max-width: 100%;
  min-width: 0;
  overflow: visible !important;
  padding: 0 !important;
  text-align: left !important;
  text-transform: uppercase;
  white-space: normal !important;
  word-break: normal;
  overflow-wrap: normal;
}

.job-dossier--modern .assignment-detail-panel .heading,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .heading,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .heading {
  color: #1f2937;
  display: block;
  font-size: 0.8125rem;
  font-weight: 900;
  line-height: 1.25;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
  word-break: normal;
  overflow-wrap: normal;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .v-btn,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .v-btn,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 button,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row button,
.job-dossier--modern .assignment-detail-panel .track-ass-btn,
.job-dossier--modern .assignment-detail-panel .download-ass-btn,
.job-dossier--modern .assignment-detail-panel .orange-button {
  align-items: center !important;
  background: transparent !important;
  border: 0.09375rem solid var(--oms-primary, #ea7a1c) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  color: var(--oms-primary, #ea7a1c) !important;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  gap: 0.25rem !important;
  height: var(--oms-control-height, 2.375rem) !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: var(--oms-control-height, 2.375rem) !important;
  min-width: max-content !important;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap !important;
  width: auto !important;
}

.job-dossier--modern .assignment-detail-panel .milestone-action-btn,
.job-dossier--modern .assignment-detail-panel .orange-button,
.job-dossier--modern .assignment-detail-panel .blue-button,
.job-dossier--modern .assignment-detail-panel .assignment-dialog-submit-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.job-dossier--modern
  .assignment-detail-panel
  .assignment-dialog-submit-btn
  .v-btn__content {
  color: #ffffff !important;
}

.job-dossier--modern .assignment-detail-panel .red-button,
.job-dossier--modern .assignment-detail-panel .v-btn.error,
.job-dossier--modern .assignment-detail-panel .v-btn.red {
  background: transparent !important;
  border-color: var(--oms-red, #be3b32) !important;
  color: var(--oms-red, #be3b32) !important;
}

.job-dossier--modern .assignment-detail-panel .v-btn--disabled,
.job-dossier--modern .assignment-detail-panel button[disabled] {
  background: var(--oms-disabled-bg, #f4f3ee) !important;
  border-color: var(--oms-disabled-border, #e9e6de) !important;
  color: var(--oms-disabled-ink, #b4b0a6) !important;
  opacity: 1 !important;
}

.job-dossier--modern .assignment-detail-panel .v-btn .v-icon,
.job-dossier--modern .assignment-detail-panel button .v-icon {
  color: currentColor !important;
  font-size: 0.9375rem !important;
  height: 0.9375rem !important;
  line-height: 0.9375rem !important;
  margin: 0 !important;
  width: 0.9375rem !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .v-btn__content,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .v-btn__content {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
}

@media (max-width: 1180px) {
  .job-dossier--modern .assignment-detail-panel .py-4.layout.row,
  .job-dossier--modern .assignment-detail-panel .layout.row.py-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .job-dossier--modern .assignment-detail-panel .py-4.layout.row,
  .job-dossier--modern .assignment-detail-panel .layout.row.py-4 {
    grid-template-columns: 1fr;
  }
}
</style>

<style scoped>
.w1300px {
  max-width: 1300px;
}
.divider {
  width: 100px;
}
.p-r-25 {
  padding-right: 25px;
}
.location {
  align-self: flex-start;
}
.v-stepper {
  width: 100%;
}

.step-clickable .primary {
  background-color: rgba(0, 0, 0, 0.38) !important;
  border-color: rgba(0, 0, 0, 0.38) !important;
}

.v-stepper__step {
  /* padding:10px!important; */
  -webkit-box-align: center !important;
  border: 2px solid #00000029 !important;
  -ms-flex-align: center !important;
  align-items: center !important;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -webkit-box-orient: horizontal !important;
  -webkit-box-direction: normal !important;
  -ms-flex-direction: row !important;
  flex-direction: row !important;
  padding: 10px !important;
  margin: 5px 20px !important;
  position: relative !important;
  min-width: 200px !important;
}
.v-stepper__header {
  flex-wrap: nowrap;
  overflow: hidden !important;
  height: auto !important;
}
.v-stepper__step__step.primary {
  background: rgba(0, 0, 0, 0.38) !important;
}
.v-stepper__step--complete > .v-stepper__step__step.primary {
  background: green !important;
}
.theme--light.v-stepper {
  background: transparent !important;
  box-shadow: none !important;
}
.spacerclass {
  max-height: none !important;
}
.spMargin {
  margin-top: -21px;
}
</style>

<style lang="scss">
/* Final OMS assignment detail surface. This block intentionally sits last to
   neutralize the older compact milestone/table styles above. */
.job-dossier--modern .assignment-detail-panel {
  background: transparent !important;
  border-top: 0 !important;
  box-sizing: border-box;
  color: var(--oms-ink, #3a382f) !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  max-height: none !important;
  overflow: visible !important;
  padding: 0 !important;
  width: 100% !important;
}

.job-dossier--modern .assignment-detail-panel,
.job-dossier--modern .assignment-detail-panel * {
  letter-spacing: 0 !important;
}

.job-dossier--modern .assignment-detail-card.v-card {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: var(--oms-radius, 1rem) !important;
  box-shadow: var(--oms-shadow, 0 0.0625rem 0.125rem rgba(26, 25, 22, 0.04)) !important;
  overflow: visible !important;
}

.job-dossier--modern .assignment-detail-body.v-card__text {
  background: transparent !important;
  overflow: visible !important;
  padding: 1rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar {
  align-items: center !important;
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.875rem !important;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 0.625rem !important;
  margin: 0 0 1rem !important;
  min-height: 3.25rem !important;
  overflow: visible !important;
  padding: 0.75rem !important;
  position: static !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar > .heading.orange--text,
.job-dossier--modern .assignment-detail-panel > .assignment-detail-card .heading.orange--text {
  color: var(--oms-primary, #ea7a1c) !important;
  flex: 1 1 auto;
  font-size: 0.9375rem !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
  margin: 0 !important;
  min-width: 12rem;
  padding: 0 !important;
  text-align: left !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar > .spacer {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-board {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.875rem !important;
  margin: 0 0 1rem !important;
  max-width: 100% !important;
  overflow-x: auto !important;
  overflow-y: visible !important;
  padding: 1rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-board::before,
.job-dossier--modern .assignment-detail-panel .assignment-milestone-track::before,
.job-dossier--modern .assignment-detail-panel .assignment-milestone-divider {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-flow.v-stepper,
.job-dossier--modern .assignment-detail-panel .assignment-milestone-track.v-stepper__header {
  background: transparent !important;
  box-shadow: none !important;
  overflow: visible !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-track.v-stepper__header {
  align-items: stretch !important;
  display: flex !important;
  flex-wrap: nowrap !important;
  gap: 0.75rem !important;
  height: auto !important;
  min-height: 0 !important;
  min-width: 100% !important;
  padding: 0 !important;
  width: max-content !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card.v-stepper__step {
  align-items: flex-start !important;
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-left: 0.1875rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: 0.75rem !important;
  box-shadow: none !important;
  display: flex !important;
  flex: 0 0 13.5rem !important;
  flex-direction: column !important;
  gap: 0.375rem !important;
  margin: 0 !important;
  max-width: 13.5rem !important;
  min-height: 8rem !important;
  min-width: 13.5rem !important;
  padding: 0.875rem !important;
  position: relative !important;
  text-align: left !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--done.v-stepper__step {
  border-left-color: #16a66a !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--active.v-stepper__step {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
  border-left-color: var(--oms-primary, #ea7a1c) !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card.v-stepper__step .v-stepper__step__step {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  box-shadow: none !important;
  color: var(--oms-muted, #74716a) !important;
  flex: 0 0 auto !important;
  font-family: "Geist Mono", ui-monospace, SFMono-Regular, Consolas, monospace !important;
  font-size: 0.6875rem !important;
  font-weight: 700 !important;
  height: 1.5rem !important;
  left: auto !important;
  line-height: 1.5rem !important;
  margin: 0 0 0.25rem !important;
  position: static !important;
  top: auto !important;
  width: 1.5rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--done.v-stepper__step .v-stepper__step__step {
  background: #16a66a !important;
  border-color: #16a66a !important;
  color: #ffffff !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--active.v-stepper__step .v-stepper__step__step {
  background: var(--oms-primary, #ea7a1c) !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card .v-stepper__label {
  display: block !important;
  max-width: 100% !important;
  min-width: 0 !important;
  text-shadow: none !important;
  width: 100% !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-badge {
  background: var(--oms-surface-soft, #faf9f6) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 999rem !important;
  color: var(--oms-muted, #74716a) !important;
  display: inline-flex !important;
  font-size: 0.625rem !important;
  font-weight: 700 !important;
  line-height: 1 !important;
  padding: 0.25rem 0.5rem !important;
  text-transform: uppercase !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--done .assignment-milestone-badge {
  background: #ecfdf3 !important;
  border-color: #bbf7d0 !important;
  color: #047857 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--active .assignment-milestone-badge {
  background: #ffedd5 !important;
  border-color: #fed7aa !important;
  color: #b45309 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-title {
  color: var(--oms-ink-strong, #1a1916) !important;
  display: block !important;
  font-size: 0.8125rem !important;
  font-weight: 700 !important;
  line-height: 1.25 !important;
  margin: 0.125rem 0 0 !important;
  white-space: normal !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-meta,
.job-dossier--modern .assignment-detail-panel .assignment-milestone-hint {
  align-items: center !important;
  color: var(--oms-muted, #74716a) !important;
  display: flex !important;
  font-size: 0.6875rem !important;
  font-weight: 500 !important;
  gap: 0.25rem !important;
  line-height: 1.3 !important;
  margin-top: 0.125rem !important;
  white-space: normal !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-meta .v-icon,
.job-dossier--modern .assignment-detail-panel .assignment-milestone-comment.viewDetail,
.job-dossier--modern .assignment-detail-panel .assignment-milestone-reverse {
  color: currentColor !important;
  font-size: 1rem !important;
  height: 1rem !important;
  line-height: 1rem !important;
  margin: 0 !important;
  width: 1rem !important;
}

.job-dossier--modern .assignment-detail-panel .my-1.mb-4 {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .py-4.layout.row,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 {
  align-items: stretch !important;
  border-top: 0 !important;
  display: grid !important;
  gap: 0.75rem !important;
  grid-template-columns: repeat(auto-fit, minmax(14rem, 1fr)) !important;
  margin: 0 0 0.75rem !important;
  overflow: visible !important;
  padding: 0 !important;
  width: 100% !important;
}

/* Contained milestone strip: one rail inside the board, never spilling into the
   rest of the expanded assignment UI. */
.job-dossier--modern .assignment-detail-panel .assignment-milestone-board {
  overflow-x: auto !important;
  overflow-y: hidden !important;
  padding: 1rem 0.875rem 0.875rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-track.v-stepper__header {
  align-items: flex-start !important;
  gap: 1.5rem !important;
  isolation: isolate;
  min-height: 6.25rem !important;
  min-width: 100% !important;
  overflow: visible !important;
  padding: 0 0.75rem !important;
  position: relative !important;
  width: max-content !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-track.v-stepper__header::before {
  display: none !important;
}

.job-dossier--modern
  .assignment-detail-panel
  .assignment-milestone-card.v-stepper__step:not(:last-child)::after {
  background: var(--oms-control-border, #e4e1d9) !important;
  border-radius: 999rem !important;
  content: "" !important;
  display: block !important;
  height: 0.1875rem !important;
  left: 0.75rem !important;
  pointer-events: none !important;
  position: absolute !important;
  top: 0.875rem !important;
  width: calc(100% + 1.5rem) !important;
  z-index: 0 !important;
}

.job-dossier--modern
  .assignment-detail-panel
  .assignment-milestone-card.v-stepper__step:last-child::after {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card.v-stepper__step {
  background: transparent !important;
  border: 0 !important;
  border-left: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  flex: 0 0 12.5rem !important;
  max-width: 12.5rem !important;
  min-height: 5.75rem !important;
  min-width: 12.5rem !important;
  overflow: visible !important;
  padding: 2.375rem 0 0 !important;
  position: relative !important;
  z-index: 1 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card.v-stepper__step::before {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card.v-stepper__step .v-stepper__step__step {
  align-items: center !important;
  display: inline-flex !important;
  justify-content: center !important;
  left: 0 !important;
  margin: 0 !important;
  position: absolute !important;
  top: 0.125rem !important;
  z-index: 2 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card .v-stepper__label {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.75rem !important;
  box-shadow: none !important;
  display: block !important;
  min-height: 4rem !important;
  padding: 0.625rem !important;
  position: relative !important;
  z-index: 1 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-card--active .v-stepper__label {
  background: #fff7ed !important;
  border-color: #fed7aa !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > .flex,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > .flex,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0.75rem !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex: none !important;
  flex-direction: column !important;
  gap: 0.375rem !important;
  justify-content: center !important;
  max-width: 100% !important;
  min-height: 4.25rem !important;
  min-width: 0 !important;
  padding: 0.75rem !important;
  width: 100% !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div > .flex,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div > .flex {
  border: 0 !important;
  flex: none !important;
  max-width: 100% !important;
  box-shadow: none !important;
  min-height: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  width: 100% !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > .flex:empty,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > .flex:empty,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div:empty,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div:empty {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .subheading.muted,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .subheading.muted,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .subheading.muted {
  color: var(--oms-muted, #74716a) !important;
  display: block !important;
  font-size: 0.6875rem !important;
  font-weight: 600 !important;
  line-height: 1.25 !important;
  margin: 0 !important;
  overflow: visible !important;
  padding: 0 !important;
  text-align: left !important;
  text-transform: uppercase !important;
  white-space: normal !important;
}

.job-dossier--modern .assignment-detail-panel .heading,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .heading,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .heading {
  color: var(--oms-ink-strong, #1a1916) !important;
  display: block !important;
  font-size: 0.875rem !important;
  font-weight: 700 !important;
  line-height: 1.35 !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: visible !important;
  text-overflow: initial !important;
  white-space: normal !important;
  word-break: break-word !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 .heading > div,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row .heading > div {
  align-items: center !important;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 0.5rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-card .v-btn:not(.v-btn--icon):not(.v-btn--fab),
.job-dossier--modern .assignment-detail-panel .assignment-detail-card button:not(.v-btn--icon):not(.v-btn--fab),
.job-dossier--modern .assignment-detail-panel .assignment-detail-card .track-ass-btn,
.job-dossier--modern .assignment-detail-panel .assignment-detail-card .download-ass-btn {
  align-items: center !important;
  background: transparent !important;
  border: 0.09375rem solid var(--oms-primary, #ea7a1c) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  color: var(--oms-primary, #ea7a1c) !important;
  display: inline-flex !important;
  font-family: "Geist", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  gap: 0.25rem !important;
  height: 2.125rem !important;
  justify-content: center !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: 2.125rem !important;
  min-width: max-content !important;
  padding: 0 0.75rem !important;
  text-transform: none !important;
  white-space: nowrap !important;
  width: auto !important;
}

.job-dossier--modern .assignment-detail-panel .milestone-action-btn,
.job-dossier--modern .assignment-detail-panel .orange-button,
.job-dossier--modern .assignment-detail-panel .blue-button {
  background: var(--oms-primary, #ea7a1c) !important;
  border-color: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.job-dossier--modern .assignment-detail-panel .pi-generate-btn,
.job-dossier--modern .assignment-detail-panel .orange-button.pi-generate-btn {
  align-items: center !important;
  display: inline-flex !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  height: 2rem !important;
  justify-content: center !important;
  letter-spacing: 0 !important;
  line-height: 1 !important;
  margin: 0.25rem 0 0 !important;
  min-height: 2rem !important;
  min-width: 5.5rem !important;
  padding: 0 0.875rem !important;
  text-align: center !important;
  vertical-align: middle;
}

.job-dossier--modern .assignment-detail-panel .pi-generate-btn::before,
.job-dossier--modern .assignment-detail-panel .orange-button.pi-generate-btn::before,
.job-dossier--modern .assignment-detail-panel .track-ass-btn.orange-button::before {
  content: none !important;
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .red-button,
.job-dossier--modern .assignment-detail-panel .v-btn.error,
.job-dossier--modern .assignment-detail-panel .v-btn.red {
  background: transparent !important;
  border-color: var(--oms-red, #be3b32) !important;
  color: var(--oms-red, #be3b32) !important;
}

.job-dossier--modern .assignment-detail-panel .v-card__actions {
  background: var(--oms-surface, #ffffff) !important;
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  padding: 0.875rem 1rem !important;
}

.job-dossier--modern .assignment-detail-panel .v-card__actions > .layout {
  align-items: center !important;
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 0.625rem !important;
  justify-content: flex-end !important;
  margin: 0 !important;
  width: 100% !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-card > .layout:last-of-type {
  align-items: center !important;
  color: var(--oms-muted, #74716a) !important;
  display: flex !important;
  font-size: 0.75rem !important;
  justify-content: flex-end !important;
  padding: 0.75rem 1rem 0 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-card > .layout:last-of-type > .flex:first-child {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-card > .layout:last-of-type > .flex:last-child {
  flex: 0 1 auto !important;
  max-width: 100% !important;
  padding-left: 0 !important;
  width: auto !important;
}

@media (max-width: 48rem) {
  .job-dossier--modern .assignment-detail-body.v-card__text {
    padding: 0.75rem !important;
  }

  .job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar,
  .job-dossier--modern .assignment-detail-panel .assignment-milestone-board {
    padding: 0.75rem !important;
  }

  .job-dossier--modern .assignment-detail-panel .py-4.layout.row,
  .job-dossier--modern .assignment-detail-panel .layout.row.py-4 {
    grid-template-columns: 1fr !important;
  }
}
</style>

<style lang="scss">
/* Damage-control pass for the opened assignment panel. Keep it compact and
   contained so rows with little/no milestone data do not create a broken page. */
.job-dossier--modern .assignment-detail-panel {
  overflow: hidden !important;
}

.job-dossier--modern .assignment-detail-panel ::-webkit-scrollbar {
  height: 0.5rem !important;
  width: 0.5rem !important;
}

.job-dossier--modern .assignment-detail-panel ::-webkit-scrollbar-track {
  background: transparent !important;
}

.job-dossier--modern .assignment-detail-panel ::-webkit-scrollbar-thumb {
  background: #d8d3ca !important;
  border-radius: 999rem !important;
}

.job-dossier--modern .assignment-detail-card.v-card {
  border-radius: 0.875rem !important;
  overflow: hidden !important;
}

.job-dossier--modern .assignment-detail-body.v-card__text {
  padding: 0.875rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar {
  background: transparent !important;
  border: 0 !important;
  border-bottom: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  border-radius: 0 !important;
  margin: 0 0 0.75rem !important;
  min-height: 0 !important;
  padding: 0 0 0.75rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar .spacer {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-toolbar > .heading.orange--text {
  min-width: 0 !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-board {
  margin: 0 0 0.875rem !important;
  max-height: 10rem !important;
}

.job-dossier--modern .assignment-detail-panel .assignment-milestone-track.v-stepper__header {
  min-height: 5.25rem !important;
}

.job-dossier--modern .assignment-detail-panel .py-4.layout.row:empty,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4:empty {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .py-4.layout.row,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 {
  gap: 0.625rem !important;
  grid-template-columns: repeat(auto-fit, minmax(18rem, 1fr)) !important;
  margin-bottom: 0.625rem !important;
}

.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > .flex,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > .flex,
.job-dossier--modern .assignment-detail-panel .layout.row.py-4 > div,
.job-dossier--modern .assignment-detail-panel .py-4.layout.row > div {
  min-height: 3.75rem !important;
  padding: 0.625rem 0.75rem !important;
}

.job-dossier--modern .assignment-detail-panel .v-card__actions {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
  min-height: 0 !important;
  padding: 0.625rem 0.875rem !important;
}

.job-dossier--modern .assignment-detail-panel .v-card__actions:empty {
  display: none !important;
}

.job-dossier--modern .assignment-detail-panel .v-card__actions > .layout {
  min-height: 0 !important;
}

/* Milestone comment dialog: same layout and colours as the other
   milestone dialogs. */
.application .v-dialog.milestone-comment-dialog {
  max-width: calc(100vw - 2rem) !important;
  width: min(30rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-card {
  border-radius: 1rem !important;
  overflow: hidden;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-head {
  align-items: center;
  background: var(--oms-peach, #fff7ed);
  border-bottom: 0.0625rem solid var(--oms-peach-border, #fed7aa);
  display: flex;
  gap: 0.75rem;
  padding: 1rem 0.75rem 1rem 1.25rem;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-head__icon {
  align-items: center;
  background: var(--oms-primary, #ea7a1c);
  border-radius: 0.75rem;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-head__icon .v-icon {
  color: #ffffff !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-head__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-head__text strong {
  color: var(--oms-navy, #1c2b5f);
  font-size: 1rem;
  font-weight: 800;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-head__text span {
  color: var(--oms-primary-dark, #d96a10);
  font-size: 0.8125rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-close.v-btn {
  align-self: flex-start;
  margin: -0.25rem 0 0 !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-close .v-icon {
  color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-body {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.125rem 1.25rem 1.25rem;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-label {
  color: var(--oms-ink, #3a382f);
  font-size: 0.75rem;
  font-weight: 700;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-input.v-input {
  font-size: 0.875rem !important;
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-input .v-input__slot {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  margin: 0 !important;
  padding: 0.5rem 0.75rem !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-input .v-input__slot::before,
.application .v-dialog.milestone-comment-dialog .milestone-comment-input .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-input.v-input--is-focused .v-input__slot {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-input textarea {
  color: var(--oms-ink-strong, #1a1916) !important;
  font-size: 0.875rem !important;
  font-weight: 500 !important;
  line-height: 1.5 !important;
  margin: 0 !important;
  -webkit-text-fill-color: var(--oms-ink-strong, #1a1916) !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-input textarea::placeholder {
  color: var(--oms-muted, #74716a) !important;
  -webkit-text-fill-color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-msg {
  border-radius: 0.625rem;
  font-size: 0.8125rem;
  font-weight: 600;
  padding: 0.5rem 0.75rem;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-msg--success {
  background: var(--oms-green-soft, #e8f5ee);
  border: 0.0625rem solid var(--oms-green-border, #cde9da);
  color: var(--oms-green, #12764c);
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-msg--error {
  background: var(--oms-red-soft, #fbeae8);
  border: 0.0625rem solid var(--oms-red-border, #f0cfcc);
  color: var(--oms-red, #be3b32);
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-actions {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  gap: 0.625rem;
  justify-content: flex-end;
  padding: 0.875rem 1.25rem;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-btn.v-btn {
  border-radius: 0.625rem !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  height: 2.5rem !important;
  margin: 0 !important;
  min-width: 6rem !important;
  text-transform: none !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-btn--ghost.v-btn {
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-btn--primary.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-btn--primary.v-btn .v-btn__content {
  color: #ffffff !important;
}

.application .v-dialog.milestone-comment-dialog .milestone-comment-btn.v-btn--disabled {
  opacity: 0.55;
}

/* "Uncheck checkpoint" confirmation: same layout and Trukkin colours as the
   "Mark milestone as reached" dialog. */
.application .v-dialog.milestone-unmark-dialog {
  max-width: calc(100vw - 2rem) !important;
  width: min(28rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-card {
  border-radius: 1rem !important;
  overflow: hidden;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head {
  align-items: flex-start;
  background: var(--oms-peach, #fff7ed);
  border-bottom: 0.0625rem solid var(--oms-peach-border, #fed7aa);
  display: flex;
  gap: 0.75rem;
  padding: 1rem 0.75rem 1rem 1.25rem;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head__icon {
  align-items: center;
  background: var(--oms-primary, #ea7a1c);
  border-radius: 0.75rem;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head__icon .v-icon {
  color: #ffffff !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head__text {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head__text strong {
  color: var(--oms-navy, #1c2b5f);
  font-size: 1rem;
  font-weight: 800;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-head__chips span {
  background: var(--oms-surface, #ffffff);
  border: 0.0625rem solid var(--oms-peach-border, #fed7aa);
  border-radius: 999rem;
  color: var(--oms-primary-dark, #d96a10);
  font-size: 0.75rem;
  font-weight: 700;
  overflow-wrap: anywhere;
  padding: 0.125rem 0.5rem;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-close.v-btn {
  margin: -0.25rem 0 0 !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-close .v-icon {
  color: var(--oms-muted, #74716a) !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-body {
  color: var(--oms-ink, #3a382f);
  font-size: 0.875rem;
  line-height: 1.5;
  margin: 0;
  padding: 1.125rem 1.25rem;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-actions {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  gap: 0.625rem;
  justify-content: flex-end;
  padding: 0.875rem 1.25rem;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-btn.v-btn {
  border-radius: 0.625rem !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  height: 2.5rem !important;
  margin: 0 !important;
  min-width: 6.5rem !important;
  text-transform: none !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-btn--ghost.v-btn {
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-btn--danger.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-btn--danger.v-btn .v-btn__content {
  color: #ffffff !important;
}

.application .v-dialog.milestone-unmark-dialog .milestone-unmark-btn.v-btn--disabled {
  opacity: 0.55;
}

/* "Mark milestone as reached" dialog. Rendered at the app root by Vuetify,
   so it is styled from this unscoped block. */
.application .v-dialog.milestone-update-dialog {
  width: min(30rem, calc(100vw - 2rem));
}

.application .v-dialog.milestone-update-dialog .milestone-update-card {
  overflow: visible !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-head {
  align-items: center;
  background: var(--oms-peach, #fff7ed);
  border-bottom: 0.0625rem solid var(--oms-peach-border, #fed7aa);
  /* The card no longer clips (so the time dropdown can overflow); round the
     header itself to match the card's corners. */
  border-radius: 1rem 1rem 0 0;
  display: flex;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
}

.application .v-dialog.milestone-update-dialog .milestone-update-head__icon {
  align-items: center;
  background: var(--oms-primary, #ea7a1c);
  border-radius: 0.75rem;
  display: inline-flex;
  flex: 0 0 auto;
  height: 2.5rem;
  justify-content: center;
  width: 2.5rem;
}

.application .v-dialog.milestone-update-dialog .milestone-update-head__icon .v-icon {
  color: #ffffff !important;
  font-size: 1.25rem !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-head__text {
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  min-width: 0;
}

.application .v-dialog.milestone-update-dialog .milestone-update-head__text strong {
  color: var(--oms-navy, #1c2b5f);
  font-size: 1rem;
  font-weight: 800;
}

.application .v-dialog.milestone-update-dialog .milestone-update-head__text span {
  color: var(--oms-primary-dark, #d96a10);
  font-size: 0.8125rem;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.application .v-dialog.milestone-update-dialog .milestone-update-body {
  padding: 1rem 1.25rem 1.25rem;
}

.application .v-dialog.milestone-update-dialog .milestone-update-hint {
  color: var(--oms-muted, #74716a);
  font-size: 0.8125rem;
  line-height: 1.45;
  margin: 0 0 0.875rem;
}

.application .v-dialog.milestone-update-dialog .milestone-update-fields {
  display: grid;
  gap: 0.75rem;
  grid-template-columns: minmax(0, 1.3fr) minmax(0, 1fr);
}

.application .v-dialog.milestone-update-dialog .milestone-update-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;
  position: relative;
}

.application .v-dialog.milestone-update-dialog .milestone-update-label {
  color: var(--oms-ink, #3a382f);
  font-size: 0.75rem;
  font-weight: 700;
}

/* Date: bordered box with the calendar icon inside. */
.application .v-dialog.milestone-update-dialog .milestone-update-input.v-input {
  font-size: 0.875rem !important;
  margin: 0 !important;
  padding: 0 !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-input .v-input__slot {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  cursor: pointer;
  margin: 0 !important;
  min-height: 2.625rem !important;
  padding: 0 0.75rem !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-input .v-input__slot::before,
.application .v-dialog.milestone-update-dialog .milestone-update-input .v-input__slot::after {
  display: none !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-input.v-input--is-focused .v-input__slot {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-input .v-input__prepend-inner {
  align-self: center !important;
  margin: 0 0.5rem 0 0 !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-input .v-input__prepend-inner .v-icon {
  color: var(--oms-primary, #ea7a1c) !important;
  font-size: 1.125rem !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-input input {
  color: var(--oms-ink-strong, #1a1916) !important;
  cursor: pointer;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  -webkit-text-fill-color: var(--oms-ink-strong, #1a1916) !important;
}

/* Time: vue-timepicker input styled to match the date box. Global dialog
   input rules use !important, so these do too. */
.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker {
  display: block !important;
  width: 100% !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker input.display-time {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  border-radius: var(--oms-control-radius, 0.625rem) !important;
  box-shadow: none !important;
  box-sizing: border-box !important;
  color: var(--oms-ink-strong, #1a1916) !important;
  font-family: inherit !important;
  font-size: 0.875rem !important;
  font-weight: 600 !important;
  height: 2.625rem !important;
  outline: none !important;
  padding: 0 2rem 0 0.75rem !important;
  -webkit-text-fill-color: var(--oms-ink-strong, #1a1916) !important;
  width: 100% !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker input.display-time:focus {
  border-color: var(--oms-primary, #ea7a1c) !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .controls {
  padding-right: 0.375rem;
}

/* The dropdown overflows the dialog instead of being clipped by it. */
.v-dialog__content > .v-dialog.milestone-update-dialog,
.application .v-dialog.milestone-update-dialog .milestone-update-card {
  overflow: visible !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown {
  background: var(--oms-surface, #ffffff) !important;
  border: 0.0625rem solid var(--oms-border, #ebe9e2);
  border-radius: 0.625rem;
  box-shadow: 0 0.75rem 2rem rgba(28, 43, 95, 0.18) !important;
  height: 12rem !important;
  overflow: hidden;
  top: calc(2.625rem + 0.25rem) !important;
  width: 100% !important;
  z-index: 20 !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown .select-list {
  height: 12rem !important;
  width: 100% !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown ul li {
  color: var(--oms-ink, #3a382f) !important;
  font-size: 0.8125rem;
  padding: 0.375rem 0 !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown ul li.hint {
  color: var(--oms-muted, #74716a) !important;
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.04em;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown ul li:not(.hint):not([disabled]):hover {
  background: var(--oms-primary-soft, #fdf0e4) !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown ul li:not([disabled]).active,
.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-time.vue__time-picker .dropdown ul.minutes {
  border-left: 0.0625rem solid var(--oms-border, #ebe9e2) !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-actions {
  border-top: 0.0625rem solid var(--oms-border, #ebe9e2);
  display: flex;
  gap: 0.625rem;
  justify-content: flex-end;
  padding: 0.875rem 1.25rem;
}

.application .v-dialog.milestone-update-dialog .milestone-update-actions .v-btn {
  border-radius: 0.625rem !important;
  font-size: 0.8125rem !important;
  font-weight: 800 !important;
  height: 2.5rem !important;
  margin: 0 !important;
  min-width: 6rem !important;
  text-transform: none !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-cancel.v-btn {
  border: 0.0625rem solid var(--oms-control-border, #e4e1d9) !important;
  color: var(--oms-ink, #3a382f) !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-submit.v-btn {
  background: var(--oms-primary, #ea7a1c) !important;
  color: #ffffff !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-submit.v-btn .v-btn__content {
  color: #ffffff !important;
}

.application .v-dialog.milestone-update-dialog .milestone-update-submit.v-btn--disabled {
  opacity: 0.55;
}

@media (max-width: 30rem) {
  .application .v-dialog.milestone-update-dialog .milestone-update-fields {
    grid-template-columns: minmax(0, 1fr);
  }
}

/* Footer: the milestone note sits on the left of the action buttons. */
.job-dossier--modern .assignment-detail-panel .assignment-detail-actions {
  align-items: center !important;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.job-dossier--modern .assignment-detail-panel .assignment-detail-note {
  color: var(--oms-muted, #74716a);
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.3;
}
</style>
